import { openBlock as s, createElementBlock as e } from "vue";
const o = (n, c) => {
  const r = n.__vccOpts || n;
  for (const [_, t] of c)
    r[_] = t;
  return r;
}, i = {}, a = { class: "icon-app-gallery color-icon" };
function d(n, c) {
  return s(), e("span", a);
}
const gS = /* @__PURE__ */ o(i, [["render", d]]), f = {}, l = { class: "icon-app-store color-icon" };
function u(n, c) {
  return s(), e("span", l);
}
const xS = /* @__PURE__ */ o(f, [["render", u]]), h = {}, $ = { class: "icon-galaxy-store color-icon" };
function p(n, c) {
  return s(), e("span", $);
}
const IS = /* @__PURE__ */ o(h, [["render", p]]), m = {}, g = { class: "icon-google-play color-icon" };
function x(n, c) {
  return s(), e("span", g);
}
const RS = /* @__PURE__ */ o(m, [["render", x]]), I = {}, R = { class: "icon-ru-store color-icon" };
function T(n, c) {
  return s(), e("span", R);
}
const TS = /* @__PURE__ */ o(I, [["render", T]]), F = {}, b = { class: "icon icon-arrow_circle_down-fill" };
function C(n, c) {
  return s(), e("span", b);
}
const FS = /* @__PURE__ */ o(F, [["render", C]]), w = {}, y = { class: "icon icon-arrow_circle_down-regular" };
function v(n, c) {
  return s(), e("span", y);
}
const bS = /* @__PURE__ */ o(w, [["render", v]]), k = {}, S = { class: "icon icon-arrow_circle_down-thin" };
function D(n, c) {
  return s(), e("span", S);
}
const CS = /* @__PURE__ */ o(k, [["render", D]]), A = {}, M = { class: "icon icon-arrow_circle_up-fill" };
function P(n, c) {
  return s(), e("span", M);
}
const wS = /* @__PURE__ */ o(A, [["render", P]]), B = {}, L = { class: "icon icon-arrow_circle_up-regular" };
function U(n, c) {
  return s(), e("span", L);
}
const yS = /* @__PURE__ */ o(B, [["render", U]]), G = {}, W = { class: "icon icon-arrow_circle_up-thin" };
function V(n, c) {
  return s(), e("span", W);
}
const vS = /* @__PURE__ */ o(G, [["render", V]]), H = {}, E = { class: "icon icon-arrow_down-regular" };
function z(n, c) {
  return s(), e("span", E);
}
const kS = /* @__PURE__ */ o(H, [["render", z]]), q = {}, N = { class: "icon icon-arrow_down-thin" };
function O(n, c) {
  return s(), e("span", N);
}
const SS = /* @__PURE__ */ o(q, [["render", O]]), K = {}, Q = { class: "icon icon-arrow_left-regular" };
function Z(n, c) {
  return s(), e("span", Q);
}
const DS = /* @__PURE__ */ o(K, [["render", Z]]), j = {}, J = { class: "icon icon-arrow_left-thin" };
function X(n, c) {
  return s(), e("span", J);
}
const AS = /* @__PURE__ */ o(j, [["render", X]]), Y = {}, nn = { class: "icon icon-arrow_right-regular" };
function cn(n, c) {
  return s(), e("span", nn);
}
const MS = /* @__PURE__ */ o(Y, [["render", cn]]), sn = {}, en = { class: "icon icon-arrow_right-thin" };
function on(n, c) {
  return s(), e("span", en);
}
const PS = /* @__PURE__ */ o(sn, [["render", on]]), rn = {}, _n = { class: "icon icon-arrow_up-regular" };
function tn(n, c) {
  return s(), e("span", _n);
}
const BS = /* @__PURE__ */ o(rn, [["render", tn]]), an = {}, dn = { class: "icon icon-arrow_up-thin" };
function fn(n, c) {
  return s(), e("span", dn);
}
const LS = /* @__PURE__ */ o(an, [["render", fn]]), ln = {}, un = { class: "icon icon-arrow_left_long-regular" };
function hn(n, c) {
  return s(), e("span", un);
}
const US = /* @__PURE__ */ o(ln, [["render", hn]]), $n = {}, pn = { class: "icon icon-arrow_left_long-thin" };
function mn(n, c) {
  return s(), e("span", pn);
}
const GS = /* @__PURE__ */ o($n, [["render", mn]]), gn = {}, xn = { class: "icon icon-chevron_double_left-regular" };
function In(n, c) {
  return s(), e("span", xn);
}
const WS = /* @__PURE__ */ o(gn, [["render", In]]), Rn = {}, Tn = { class: "icon icon-chevron_double_left-thin" };
function Fn(n, c) {
  return s(), e("span", Tn);
}
const VS = /* @__PURE__ */ o(Rn, [["render", Fn]]), bn = {}, Cn = { class: "icon icon-chevron_double_right-regular" };
function wn(n, c) {
  return s(), e("span", Cn);
}
const HS = /* @__PURE__ */ o(bn, [["render", wn]]), yn = {}, vn = { class: "icon icon-chevron_double_right-thin" };
function kn(n, c) {
  return s(), e("span", vn);
}
const ES = /* @__PURE__ */ o(yn, [["render", kn]]), Sn = {}, Dn = { class: "icon icon-chevron_down-regular" };
function An(n, c) {
  return s(), e("span", Dn);
}
const zS = /* @__PURE__ */ o(Sn, [["render", An]]), Mn = {}, Pn = { class: "icon icon-chevron_down-thin" };
function Bn(n, c) {
  return s(), e("span", Pn);
}
const qS = /* @__PURE__ */ o(Mn, [["render", Bn]]), Ln = {}, Un = { class: "icon icon-chevron_left-regular" };
function Gn(n, c) {
  return s(), e("span", Un);
}
const NS = /* @__PURE__ */ o(Ln, [["render", Gn]]), Wn = {}, Vn = { class: "icon icon-chevron_left-thin" };
function Hn(n, c) {
  return s(), e("span", Vn);
}
const OS = /* @__PURE__ */ o(Wn, [["render", Hn]]), En = {}, zn = { class: "icon icon-chevron_right-regular" };
function qn(n, c) {
  return s(), e("span", zn);
}
const KS = /* @__PURE__ */ o(En, [["render", qn]]), Nn = {}, On = { class: "icon icon-chevron_right-thin" };
function Kn(n, c) {
  return s(), e("span", On);
}
const QS = /* @__PURE__ */ o(Nn, [["render", Kn]]), Qn = {}, Zn = { class: "icon icon-chevron_up-regular" };
function jn(n, c) {
  return s(), e("span", Zn);
}
const ZS = /* @__PURE__ */ o(Qn, [["render", jn]]), Jn = {}, Xn = { class: "icon icon-chevron_up-thin" };
function Yn(n, c) {
  return s(), e("span", Xn);
}
const jS = /* @__PURE__ */ o(Jn, [["render", Yn]]), nc = {}, cc = { class: "icon icon-collapse_all-regular" };
function sc(n, c) {
  return s(), e("span", cc);
}
const JS = /* @__PURE__ */ o(nc, [["render", sc]]), ec = {}, oc = { class: "icon icon-collapse_all-thin" };
function rc(n, c) {
  return s(), e("span", oc);
}
const XS = /* @__PURE__ */ o(ec, [["render", rc]]), _c = {}, tc = { class: "icon icon-collapse-regular" };
function ic(n, c) {
  return s(), e("span", tc);
}
const YS = /* @__PURE__ */ o(_c, [["render", ic]]), ac = {}, dc = { class: "icon icon-collapse-thin" };
function fc(n, c) {
  return s(), e("span", dc);
}
const nD = /* @__PURE__ */ o(ac, [["render", fc]]), lc = {}, uc = { class: "icon icon-expand_all-regular" };
function hc(n, c) {
  return s(), e("span", uc);
}
const cD = /* @__PURE__ */ o(lc, [["render", hc]]), $c = {}, pc = { class: "icon icon-expand_all-thin" };
function mc(n, c) {
  return s(), e("span", pc);
}
const sD = /* @__PURE__ */ o($c, [["render", mc]]), gc = {}, xc = { class: "icon icon-expand-regular" };
function Ic(n, c) {
  return s(), e("span", xc);
}
const eD = /* @__PURE__ */ o(gc, [["render", Ic]]), Rc = {}, Tc = { class: "icon icon-expand-thin" };
function Fc(n, c) {
  return s(), e("span", Tc);
}
const oD = /* @__PURE__ */ o(Rc, [["render", Fc]]), bc = {}, Cc = { class: "icon icon-fullscreen_exit-regular" };
function wc(n, c) {
  return s(), e("span", Cc);
}
const rD = /* @__PURE__ */ o(bc, [["render", wc]]), yc = {}, vc = { class: "icon icon-fullscreen_exit-thin" };
function kc(n, c) {
  return s(), e("span", vc);
}
const _D = /* @__PURE__ */ o(yc, [["render", kc]]), Sc = {}, Dc = { class: "icon icon-fullscreen_open-regular" };
function Ac(n, c) {
  return s(), e("span", Dc);
}
const tD = /* @__PURE__ */ o(Sc, [["render", Ac]]), Mc = {}, Pc = { class: "icon icon-fullscreen_open-thin" };
function Bc(n, c) {
  return s(), e("span", Pc);
}
const iD = /* @__PURE__ */ o(Mc, [["render", Bc]]), Lc = {}, Uc = { class: "icon icon-north_east-regular" };
function Gc(n, c) {
  return s(), e("span", Uc);
}
const aD = /* @__PURE__ */ o(Lc, [["render", Gc]]), Wc = {}, Vc = { class: "icon icon-north_east-thin" };
function Hc(n, c) {
  return s(), e("span", Vc);
}
const dD = /* @__PURE__ */ o(Wc, [["render", Hc]]), Ec = {}, zc = { class: "icon icon-north_west-regular" };
function qc(n, c) {
  return s(), e("span", zc);
}
const fD = /* @__PURE__ */ o(Ec, [["render", qc]]), Nc = {}, Oc = { class: "icon icon-north_west-thin" };
function Kc(n, c) {
  return s(), e("span", Oc);
}
const lD = /* @__PURE__ */ o(Nc, [["render", Kc]]), Qc = {}, Zc = { class: "icon icon-redo-regular" };
function jc(n, c) {
  return s(), e("span", Zc);
}
const uD = /* @__PURE__ */ o(Qc, [["render", jc]]), Jc = {}, Xc = { class: "icon icon-redo-thin" };
function Yc(n, c) {
  return s(), e("span", Xc);
}
const hD = /* @__PURE__ */ o(Jc, [["render", Yc]]), ns = {}, cs = { class: "icon icon-refresh-regular" };
function ss(n, c) {
  return s(), e("span", cs);
}
const $D = /* @__PURE__ */ o(ns, [["render", ss]]), es = {}, os = { class: "icon icon-refresh-thin" };
function rs(n, c) {
  return s(), e("span", os);
}
const pD = /* @__PURE__ */ o(es, [["render", rs]]), _s = {}, ts = { class: "icon icon-reply-regular" };
function is(n, c) {
  return s(), e("span", ts);
}
const mD = /* @__PURE__ */ o(_s, [["render", is]]), as = {}, ds = { class: "icon icon-reply-thin" };
function fs(n, c) {
  return s(), e("span", ds);
}
const gD = /* @__PURE__ */ o(as, [["render", fs]]), ls = {}, us = { class: "icon icon-restore-regular" };
function hs(n, c) {
  return s(), e("span", us);
}
const xD = /* @__PURE__ */ o(ls, [["render", hs]]), $s = {}, ps = { class: "icon icon-restore-thin" };
function ms(n, c) {
  return s(), e("span", ps);
}
const ID = /* @__PURE__ */ o($s, [["render", ms]]), gs = {}, xs = { class: "icon icon-sort_horizont-regular" };
function Is(n, c) {
  return s(), e("span", xs);
}
const RD = /* @__PURE__ */ o(gs, [["render", Is]]), Rs = {}, Ts = { class: "icon icon-sort_horizont-thin" };
function Fs(n, c) {
  return s(), e("span", Ts);
}
const TD = /* @__PURE__ */ o(Rs, [["render", Fs]]), bs = {}, Cs = { class: "icon icon-sort_vert-regular" };
function ws(n, c) {
  return s(), e("span", Cs);
}
const FD = /* @__PURE__ */ o(bs, [["render", ws]]), ys = {}, vs = { class: "icon icon-sort_vert-thin" };
function ks(n, c) {
  return s(), e("span", vs);
}
const bD = /* @__PURE__ */ o(ys, [["render", ks]]), Ss = {}, Ds = { class: "sort-icon icon-sort_up-regular" };
function As(n, c) {
  return s(), e("span", Ds);
}
const CD = /* @__PURE__ */ o(Ss, [["render", As]]), Ms = {}, Ps = { class: "sort-icon icon-sort_down-regular" };
function Bs(n, c) {
  return s(), e("span", Ps);
}
const wD = /* @__PURE__ */ o(Ms, [["render", Bs]]), Ls = {}, Us = { class: "icon icon-south_east-regular" };
function Gs(n, c) {
  return s(), e("span", Us);
}
const yD = /* @__PURE__ */ o(Ls, [["render", Gs]]), Ws = {}, Vs = { class: "icon icon-south_east-thin" };
function Hs(n, c) {
  return s(), e("span", Vs);
}
const vD = /* @__PURE__ */ o(Ws, [["render", Hs]]), Es = {}, zs = { class: "icon icon-south_west-regular" };
function qs(n, c) {
  return s(), e("span", zs);
}
const kD = /* @__PURE__ */ o(Es, [["render", qs]]), Ns = {}, Os = { class: "icon icon-south_west-thin" };
function Ks(n, c) {
  return s(), e("span", Os);
}
const SD = /* @__PURE__ */ o(Ns, [["render", Ks]]), Qs = {}, Zs = { class: "icon icon-sync-regular" };
function js(n, c) {
  return s(), e("span", Zs);
}
const DD = /* @__PURE__ */ o(Qs, [["render", js]]), Js = {}, Xs = { class: "icon icon-sync-thin" };
function Ys(n, c) {
  return s(), e("span", Xs);
}
const AD = /* @__PURE__ */ o(Js, [["render", Ys]]), ne = {}, ce = { class: "icon-empty-flag country-icon" };
function se(n, c) {
  return s(), e("span", ce);
}
const MD = /* @__PURE__ */ o(ne, [["render", se]]), ee = {}, oe = { class: "icon-empty-flag-square color-icon" };
function re(n, c) {
  return s(), e("span", oe);
}
const PD = /* @__PURE__ */ o(ee, [["render", re]]), _e = {}, te = { class: "icon-kz country-icon" };
function ie(n, c) {
  return s(), e("span", te);
}
const BD = /* @__PURE__ */ o(_e, [["render", ie]]), ae = {}, de = { class: "icon-kz-square color-icon" };
function fe(n, c) {
  return s(), e("span", de);
}
const LD = /* @__PURE__ */ o(ae, [["render", fe]]), le = {}, ue = { class: "icon-md country-icon" };
function he(n, c) {
  return s(), e("span", ue);
}
const UD = /* @__PURE__ */ o(le, [["render", he]]), $e = {}, pe = { class: "icon-md-square color-icon" };
function me(n, c) {
  return s(), e("span", pe);
}
const GD = /* @__PURE__ */ o($e, [["render", me]]), ge = {}, xe = { class: "icon-ru country-icon" };
function Ie(n, c) {
  return s(), e("span", xe);
}
const WD = /* @__PURE__ */ o(ge, [["render", Ie]]), Re = {}, Te = { class: "icon-ru-square color-icon" };
function Fe(n, c) {
  return s(), e("span", Te);
}
const VD = /* @__PURE__ */ o(Re, [["render", Fe]]), be = {}, Ce = { class: "icon icon-alarm-fill" };
function we(n, c) {
  return s(), e("span", Ce);
}
const HD = /* @__PURE__ */ o(be, [["render", we]]), ye = {}, ve = { class: "icon icon-alarm-regular" };
function ke(n, c) {
  return s(), e("span", ve);
}
const ED = /* @__PURE__ */ o(ye, [["render", ke]]), Se = {}, De = { class: "icon icon-alarm-thin" };
function Ae(n, c) {
  return s(), e("span", De);
}
const zD = /* @__PURE__ */ o(Se, [["render", Ae]]), Me = {}, Pe = { class: "icon icon-calendar_month-fill" };
function Be(n, c) {
  return s(), e("span", Pe);
}
const qD = /* @__PURE__ */ o(Me, [["render", Be]]), Le = {}, Ue = { class: "icon icon-calendar_month-regular" };
function Ge(n, c) {
  return s(), e("span", Ue);
}
const ND = /* @__PURE__ */ o(Le, [["render", Ge]]), We = {}, Ve = { class: "icon icon-calendar_month-thin" };
function He(n, c) {
  return s(), e("span", Ve);
}
const OD = /* @__PURE__ */ o(We, [["render", He]]), Ee = {}, ze = { class: "icon icon-calendar_today-fill" };
function qe(n, c) {
  return s(), e("span", ze);
}
const KD = /* @__PURE__ */ o(Ee, [["render", qe]]), Ne = {}, Oe = { class: "icon icon-calendar_today-regular" };
function Ke(n, c) {
  return s(), e("span", Oe);
}
const QD = /* @__PURE__ */ o(Ne, [["render", Ke]]), Qe = {}, Ze = { class: "icon icon-calendar_today-thin" };
function je(n, c) {
  return s(), e("span", Ze);
}
const ZD = /* @__PURE__ */ o(Qe, [["render", je]]), Je = {}, Xe = { class: "icon icon-calendar_view_day-regular" };
function Ye(n, c) {
  return s(), e("span", Xe);
}
const jD = /* @__PURE__ */ o(Je, [["render", Ye]]), no = {}, co = { class: "icon icon-calendar_view_day-thin" };
function so(n, c) {
  return s(), e("span", co);
}
const JD = /* @__PURE__ */ o(no, [["render", so]]), eo = {}, oo = { class: "icon icon-calendar_view_month-regular" };
function ro(n, c) {
  return s(), e("span", oo);
}
const XD = /* @__PURE__ */ o(eo, [["render", ro]]), _o = {}, to = { class: "icon icon-calendar_view_month-thin" };
function io(n, c) {
  return s(), e("span", to);
}
const YD = /* @__PURE__ */ o(_o, [["render", io]]), ao = {}, fo = { class: "icon icon-calendar_view_week-regular" };
function lo(n, c) {
  return s(), e("span", fo);
}
const nA = /* @__PURE__ */ o(ao, [["render", lo]]), uo = {}, ho = { class: "icon icon-calendar_view_week-thin" };
function $o(n, c) {
  return s(), e("span", ho);
}
const cA = /* @__PURE__ */ o(uo, [["render", $o]]), po = {}, mo = { class: "icon icon-calendar_week-fill" };
function go(n, c) {
  return s(), e("span", mo);
}
const sA = /* @__PURE__ */ o(po, [["render", go]]), xo = {}, Io = { class: "icon icon-calendar_week-regular" };
function Ro(n, c) {
  return s(), e("span", Io);
}
const eA = /* @__PURE__ */ o(xo, [["render", Ro]]), To = {}, Fo = { class: "icon icon-calendar_week-thin" };
function bo(n, c) {
  return s(), e("span", Fo);
}
const oA = /* @__PURE__ */ o(To, [["render", bo]]), Co = {}, wo = { class: "icon icon-history-regular" };
function yo(n, c) {
  return s(), e("span", wo);
}
const rA = /* @__PURE__ */ o(Co, [["render", yo]]), vo = {}, ko = { class: "icon icon-history-thin" };
function So(n, c) {
  return s(), e("span", ko);
}
const _A = /* @__PURE__ */ o(vo, [["render", So]]), Do = {}, Ao = { class: "icon icon-schedule-fill" };
function Mo(n, c) {
  return s(), e("span", Ao);
}
const tA = /* @__PURE__ */ o(Do, [["render", Mo]]), Po = {}, Bo = { class: "icon icon-schedule-regular" };
function Lo(n, c) {
  return s(), e("span", Bo);
}
const iA = /* @__PURE__ */ o(Po, [["render", Lo]]), Uo = {}, Go = { class: "icon icon-schedule-thin" };
function Wo(n, c) {
  return s(), e("span", Go);
}
const aA = /* @__PURE__ */ o(Uo, [["render", Wo]]), Vo = {}, Ho = { class: "icon icon-today-fill" };
function Eo(n, c) {
  return s(), e("span", Ho);
}
const dA = /* @__PURE__ */ o(Vo, [["render", Eo]]), zo = {}, qo = { class: "icon icon-today-regular" };
function No(n, c) {
  return s(), e("span", qo);
}
const fA = /* @__PURE__ */ o(zo, [["render", No]]), Oo = {}, Ko = { class: "icon icon-today-thin" };
function Qo(n, c) {
  return s(), e("span", Ko);
}
const lA = /* @__PURE__ */ o(Oo, [["render", Qo]]), Zo = {}, jo = { class: "icon icon-update-regular" };
function Jo(n, c) {
  return s(), e("span", jo);
}
const uA = /* @__PURE__ */ o(Zo, [["render", Jo]]), Xo = {}, Yo = { class: "icon icon-update-thin" };
function nr(n, c) {
  return s(), e("span", Yo);
}
const hA = /* @__PURE__ */ o(Xo, [["render", nr]]), cr = {}, sr = { class: "icon-mastercard color-icon" };
function er(n, c) {
  return s(), e("span", sr);
}
const $A = /* @__PURE__ */ o(cr, [["render", er]]), or = {}, rr = { class: "icon-mastercard-dark icon" };
function _r(n, c) {
  return s(), e("span", rr);
}
const pA = /* @__PURE__ */ o(or, [["render", _r]]), tr = {}, ir = { class: "icon-maestro color-icon" };
function ar(n, c) {
  return s(), e("span", ir);
}
const mA = /* @__PURE__ */ o(tr, [["render", ar]]), dr = {}, fr = { class: "icon-maestro-dark icon" };
function lr(n, c) {
  return s(), e("span", fr);
}
const gA = /* @__PURE__ */ o(dr, [["render", lr]]), ur = {}, hr = { class: "icon-mir color-icon" };
function $r(n, c) {
  return s(), e("span", hr);
}
const xA = /* @__PURE__ */ o(ur, [["render", $r]]), pr = {}, mr = { class: "icon-mir-dark icon" };
function gr(n, c) {
  return s(), e("span", mr);
}
const IA = /* @__PURE__ */ o(pr, [["render", gr]]), xr = {}, Ir = { class: "icon-visa color-icon" };
function Rr(n, c) {
  return s(), e("span", Ir);
}
const RA = /* @__PURE__ */ o(xr, [["render", Rr]]), Tr = {}, Fr = { class: "icon-visa-dark icon" };
function br(n, c) {
  return s(), e("span", Fr);
}
const TA = /* @__PURE__ */ o(Tr, [["render", br]]), Cr = {}, wr = { class: "icon icon-delivery-regular" };
function yr(n, c) {
  return s(), e("span", wr);
}
const FA = /* @__PURE__ */ o(Cr, [["render", yr]]), vr = {}, kr = { class: "icon icon-delivery-thin" };
function Sr(n, c) {
  return s(), e("span", kr);
}
const bA = /* @__PURE__ */ o(vr, [["render", Sr]]), Dr = {}, Ar = { class: "icon icon-print-regular" };
function Mr(n, c) {
  return s(), e("span", Ar);
}
const CA = /* @__PURE__ */ o(Dr, [["render", Mr]]), Pr = {}, Br = { class: "icon icon-print-thin" };
function Lr(n, c) {
  return s(), e("span", Br);
}
const wA = /* @__PURE__ */ o(Pr, [["render", Lr]]), Ur = {}, Gr = { class: "icon icon-trash-fill" };
function Wr(n, c) {
  return s(), e("span", Gr);
}
const yA = /* @__PURE__ */ o(Ur, [["render", Wr]]), Vr = {}, Hr = { class: "icon icon-trash-regular" };
function Er(n, c) {
  return s(), e("span", Hr);
}
const vA = /* @__PURE__ */ o(Vr, [["render", Er]]), zr = {}, qr = { class: "icon icon-trash-thin" };
function Nr(n, c) {
  return s(), e("span", qr);
}
const kA = /* @__PURE__ */ o(zr, [["render", Nr]]), Or = {}, Kr = { class: "icon icon-car-regular" };
function Qr(n, c) {
  return s(), e("span", Kr);
}
const SA = /* @__PURE__ */ o(Or, [["render", Qr]]), Zr = {}, jr = { class: "icon icon-car-thin" };
function Jr(n, c) {
  return s(), e("span", jr);
}
const DA = /* @__PURE__ */ o(Zr, [["render", Jr]]), Xr = {}, Yr = { class: "icon icon-car-fill" };
function n_(n, c) {
  return s(), e("span", Yr);
}
const AA = /* @__PURE__ */ o(Xr, [["render", n_]]), c_ = {}, s_ = { class: "icon icon-cookie-fill" };
function e_(n, c) {
  return s(), e("span", s_);
}
const MA = /* @__PURE__ */ o(c_, [["render", e_]]), o_ = {}, r_ = { class: "icon icon-cookie-regular" };
function __(n, c) {
  return s(), e("span", r_);
}
const PA = /* @__PURE__ */ o(o_, [["render", __]]), t_ = {}, i_ = { class: "icon icon-cookie-thin" };
function a_(n, c) {
  return s(), e("span", i_);
}
const BA = /* @__PURE__ */ o(t_, [["render", a_]]), d_ = {}, f_ = { class: "icon icon-food-regular" };
function l_(n, c) {
  return s(), e("span", f_);
}
const LA = /* @__PURE__ */ o(d_, [["render", l_]]), u_ = {}, h_ = { class: "icon icon-food-thin" };
function $_(n, c) {
  return s(), e("span", h_);
}
const UA = /* @__PURE__ */ o(u_, [["render", $_]]), p_ = {}, m_ = { class: "icon icon-fuel-regular" };
function g_(n, c) {
  return s(), e("span", m_);
}
const GA = /* @__PURE__ */ o(p_, [["render", g_]]), x_ = {}, I_ = { class: "icon icon-fuel-thin" };
function R_(n, c) {
  return s(), e("span", I_);
}
const WA = /* @__PURE__ */ o(x_, [["render", R_]]), T_ = {}, F_ = { class: "icon icon-rc-mobile-regular" };
function b_(n, c) {
  return s(), e("span", F_);
}
const VA = /* @__PURE__ */ o(T_, [["render", b_]]), C_ = {}, w_ = { class: "icon icon-rc-mobile-thin" };
function y_(n, c) {
  return s(), e("span", w_);
}
const HA = /* @__PURE__ */ o(C_, [["render", y_]]), v_ = {}, k_ = { class: "icon icon-service-regular" };
function S_(n, c) {
  return s(), e("span", k_);
}
const EA = /* @__PURE__ */ o(v_, [["render", S_]]), D_ = {}, A_ = { class: "icon icon-service-thin" };
function M_(n, c) {
  return s(), e("span", A_);
}
const zA = /* @__PURE__ */ o(D_, [["render", M_]]), P_ = {}, B_ = { class: "icon icon-service-fill" };
function L_(n, c) {
  return s(), e("span", B_);
}
const qA = /* @__PURE__ */ o(P_, [["render", L_]]), U_ = {}, G_ = { class: "icon icon-taxi-fill" };
function W_(n, c) {
  return s(), e("span", G_);
}
const NA = /* @__PURE__ */ o(U_, [["render", W_]]), V_ = {}, H_ = { class: "icon icon-taxi-regular" };
function E_(n, c) {
  return s(), e("span", H_);
}
const OA = /* @__PURE__ */ o(V_, [["render", E_]]), z_ = {}, q_ = { class: "icon icon-taxi-thin" };
function N_(n, c) {
  return s(), e("span", q_);
}
const KA = /* @__PURE__ */ o(z_, [["render", N_]]), O_ = {}, K_ = { class: "icon-dzen color-icon" };
function Q_(n, c) {
  return s(), e("span", K_);
}
const QA = /* @__PURE__ */ o(O_, [["render", Q_]]), Z_ = {}, j_ = { class: "icon icon-dzen-dark" };
function J_(n, c) {
  return s(), e("span", j_);
}
const ZA = /* @__PURE__ */ o(Z_, [["render", J_]]), X_ = {}, Y_ = { class: "icon-ok color-icon" };
function nt(n, c) {
  return s(), e("span", Y_);
}
const jA = /* @__PURE__ */ o(X_, [["render", nt]]), ct = {}, st = { class: "icon-ok-dark icon" };
function et(n, c) {
  return s(), e("span", st);
}
const JA = /* @__PURE__ */ o(ct, [["render", et]]), ot = {}, rt = { class: "icon-facebook color-icon" };
function _t(n, c) {
  return s(), e("span", rt);
}
const XA = /* @__PURE__ */ o(ot, [["render", _t]]), tt = {}, it = { class: "icon-facebook-dark color-icon" };
function at(n, c) {
  return s(), e("span", it);
}
const YA = /* @__PURE__ */ o(tt, [["render", at]]), dt = {}, ft = { class: "icon-instagram color-icon" };
function lt(n, c) {
  return s(), e("span", ft);
}
const nM = /* @__PURE__ */ o(dt, [["render", lt]]), ut = {}, ht = { class: "icon-instagram-dark icon" };
function $t(n, c) {
  return s(), e("span", ht);
}
const cM = /* @__PURE__ */ o(ut, [["render", $t]]), pt = {}, mt = { class: "icon-rutube color-icon" };
function gt(n, c) {
  return s(), e("span", mt);
}
const sM = /* @__PURE__ */ o(pt, [["render", gt]]), xt = {}, It = { class: "icon-rutube-dark icon" };
function Rt(n, c) {
  return s(), e("span", It);
}
const eM = /* @__PURE__ */ o(xt, [["render", Rt]]), Tt = {}, Ft = { class: "icon-telegram color-icon" };
function bt(n, c) {
  return s(), e("span", Ft);
}
const oM = /* @__PURE__ */ o(Tt, [["render", bt]]), Ct = {}, wt = { class: "icon icon-telegram-dark" };
function yt(n, c) {
  return s(), e("span", wt);
}
const rM = /* @__PURE__ */ o(Ct, [["render", yt]]), vt = {}, kt = { class: "icon-vk color-icon" };
function St(n, c) {
  return s(), e("span", kt);
}
const _M = /* @__PURE__ */ o(vt, [["render", St]]), Dt = {}, At = { class: "icon icon-vk-dark" };
function Mt(n, c) {
  return s(), e("span", At);
}
const tM = /* @__PURE__ */ o(Dt, [["render", Mt]]), Pt = {}, Bt = { class: "icon-whatsapp color-icon" };
function Lt(n, c) {
  return s(), e("span", Bt);
}
const iM = /* @__PURE__ */ o(Pt, [["render", Lt]]), Ut = {}, Gt = { class: "icon icon-whatsapp-dark" };
function Wt(n, c) {
  return s(), e("span", Gt);
}
const aM = /* @__PURE__ */ o(Ut, [["render", Wt]]), Vt = {}, Ht = { class: "icon-youtube color-icon" };
function Et(n, c) {
  return s(), e("span", Ht);
}
const dM = /* @__PURE__ */ o(Vt, [["render", Et]]), zt = {}, qt = { class: "icon icon-youtube-dark" };
function Nt(n, c) {
  return s(), e("span", qt);
}
const fM = /* @__PURE__ */ o(zt, [["render", Nt]]), Ot = {}, Kt = { class: "icon icon-cashback-regular" };
function Qt(n, c) {
  return s(), e("span", Kt);
}
const lM = /* @__PURE__ */ o(Ot, [["render", Qt]]), Zt = {}, jt = { class: "icon icon-cashback-thin" };
function Jt(n, c) {
  return s(), e("span", jt);
}
const uM = /* @__PURE__ */ o(Zt, [["render", Jt]]), Xt = {}, Yt = { class: "icon icon-first-regular" };
function ni(n, c) {
  return s(), e("span", Yt);
}
const hM = /* @__PURE__ */ o(Xt, [["render", ni]]), ci = {}, si = { class: "icon icon-first-thin" };
function ei(n, c) {
  return s(), e("span", si);
}
const $M = /* @__PURE__ */ o(ci, [["render", ei]]), oi = {}, ri = { class: "icon icon-first-fill" };
function _i(n, c) {
  return s(), e("span", ri);
}
const pM = /* @__PURE__ */ o(oi, [["render", _i]]), ti = {}, ii = { class: "icon icon-pay-fill" };
function ai(n, c) {
  return s(), e("span", ii);
}
const mM = /* @__PURE__ */ o(ti, [["render", ai]]), di = {}, fi = { class: "icon icon-pay-regular" };
function li(n, c) {
  return s(), e("span", fi);
}
const gM = /* @__PURE__ */ o(di, [["render", li]]), ui = {}, hi = { class: "icon icon-pay-thin" };
function $i(n, c) {
  return s(), e("span", hi);
}
const xM = /* @__PURE__ */ o(ui, [["render", $i]]), pi = {}, mi = { class: "icon icon-percent-fill" };
function gi(n, c) {
  return s(), e("span", mi);
}
const IM = /* @__PURE__ */ o(pi, [["render", gi]]), xi = {}, Ii = { class: "icon icon-percent-regular" };
function Ri(n, c) {
  return s(), e("span", Ii);
}
const RM = /* @__PURE__ */ o(xi, [["render", Ri]]), Ti = {}, Fi = { class: "icon icon-percent-thin" };
function bi(n, c) {
  return s(), e("span", Fi);
}
const TM = /* @__PURE__ */ o(Ti, [["render", bi]]), Ci = {}, wi = { class: "icon icon-account-transition-regular" };
function yi(n, c) {
  return s(), e("span", wi);
}
const FM = /* @__PURE__ */ o(Ci, [["render", yi]]), vi = {}, ki = { class: "icon icon-account-transition-thin" };
function Si(n, c) {
  return s(), e("span", ki);
}
const bM = /* @__PURE__ */ o(vi, [["render", Si]]), Di = {}, Ai = { class: "icon icon-cashflow-regular" };
function Mi(n, c) {
  return s(), e("span", Ai);
}
const CM = /* @__PURE__ */ o(Di, [["render", Mi]]), Pi = {}, Bi = { class: "icon icon-cashflow-thin" };
function Li(n, c) {
  return s(), e("span", Bi);
}
const wM = /* @__PURE__ */ o(Pi, [["render", Li]]), Ui = {}, Gi = { class: "icon icon-client-transition-regular" };
function Wi(n, c) {
  return s(), e("span", Gi);
}
const yM = /* @__PURE__ */ o(Ui, [["render", Wi]]), Vi = {}, Hi = { class: "icon icon-client-transition-thin" };
function Ei(n, c) {
  return s(), e("span", Hi);
}
const vM = /* @__PURE__ */ o(Vi, [["render", Ei]]), zi = {}, qi = { class: "icon icon-money-output-regular" };
function Ni(n, c) {
  return s(), e("span", qi);
}
const kM = /* @__PURE__ */ o(zi, [["render", Ni]]), Oi = {}, Ki = { class: "icon icon-money-output-thin" };
function Qi(n, c) {
  return s(), e("span", Ki);
}
const SM = /* @__PURE__ */ o(Oi, [["render", Qi]]), Zi = {}, ji = { class: "icon icon-age-fill" };
function Ji(n, c) {
  return s(), e("span", ji);
}
const DM = /* @__PURE__ */ o(Zi, [["render", Ji]]), Xi = {}, Yi = { class: "icon icon-age-regular" };
function na(n, c) {
  return s(), e("span", Yi);
}
const AM = /* @__PURE__ */ o(Xi, [["render", na]]), ca = {}, sa = { class: "icon icon-age-thin" };
function ea(n, c) {
  return s(), e("span", sa);
}
const MM = /* @__PURE__ */ o(ca, [["render", ea]]), oa = {}, ra = { class: "icon icon-chair-fill" };
function _a(n, c) {
  return s(), e("span", ra);
}
const PM = /* @__PURE__ */ o(oa, [["render", _a]]), ta = {}, ia = { class: "icon icon-chair-regular" };
function aa(n, c) {
  return s(), e("span", ia);
}
const BM = /* @__PURE__ */ o(ta, [["render", aa]]), da = {}, fa = { class: "icon icon-chair-thin" };
function la(n, c) {
  return s(), e("span", fa);
}
const LM = /* @__PURE__ */ o(da, [["render", la]]), ua = {}, ha = { class: "icon icon-child-fill" };
function $a(n, c) {
  return s(), e("span", ha);
}
const UM = /* @__PURE__ */ o(ua, [["render", $a]]), pa = {}, ma = { class: "icon icon-child-regular" };
function ga(n, c) {
  return s(), e("span", ma);
}
const GM = /* @__PURE__ */ o(pa, [["render", ga]]), xa = {}, Ia = { class: "icon icon-child-thin" };
function Ra(n, c) {
  return s(), e("span", Ia);
}
const WM = /* @__PURE__ */ o(xa, [["render", Ra]]), Ta = {}, Fa = { class: "icon icon-pet-paw-fill" };
function ba(n, c) {
  return s(), e("span", Fa);
}
const VM = /* @__PURE__ */ o(Ta, [["render", ba]]), Ca = {}, wa = { class: "icon icon-pet-paw-regular" };
function ya(n, c) {
  return s(), e("span", wa);
}
const HM = /* @__PURE__ */ o(Ca, [["render", ya]]), va = {}, ka = { class: "icon icon-pet-paw-thin" };
function Sa(n, c) {
  return s(), e("span", ka);
}
const EM = /* @__PURE__ */ o(va, [["render", Sa]]), Da = {}, Aa = { class: "icon icon-wi-fi-regular" };
function Ma(n, c) {
  return s(), e("span", Aa);
}
const zM = /* @__PURE__ */ o(Da, [["render", Ma]]), Pa = {}, Ba = { class: "icon icon-wi-fi-thin" };
function La(n, c) {
  return s(), e("span", Ba);
}
const qM = /* @__PURE__ */ o(Pa, [["render", La]]), Ua = {}, Ga = { class: "icon icon-link_mobile-regular" };
function Wa(n, c) {
  return s(), e("span", Ga);
}
const NM = /* @__PURE__ */ o(Ua, [["render", Wa]]), Va = {}, Ha = { class: "icon icon-link_mobile-thin" };
function Ea(n, c) {
  return s(), e("span", Ha);
}
const OM = /* @__PURE__ */ o(Va, [["render", Ea]]), za = {}, qa = { class: "icon icon-account-fill" };
function Na(n, c) {
  return s(), e("span", qa);
}
const KM = /* @__PURE__ */ o(za, [["render", Na]]), Oa = {}, Ka = { class: "icon icon-account-regular" };
function Qa(n, c) {
  return s(), e("span", Ka);
}
const QM = /* @__PURE__ */ o(Oa, [["render", Qa]]), Za = {}, ja = { class: "icon icon-account-thin" };
function Ja(n, c) {
  return s(), e("span", ja);
}
const ZM = /* @__PURE__ */ o(Za, [["render", Ja]]), Xa = {}, Ya = { class: "icon icon-group_add-fill" };
function nd(n, c) {
  return s(), e("span", Ya);
}
const jM = /* @__PURE__ */ o(Xa, [["render", nd]]), cd = {}, sd = { class: "icon icon-group_add-regular" };
function ed(n, c) {
  return s(), e("span", sd);
}
const JM = /* @__PURE__ */ o(cd, [["render", ed]]), od = {}, rd = { class: "icon icon-group_add-thin" };
function _d(n, c) {
  return s(), e("span", rd);
}
const XM = /* @__PURE__ */ o(od, [["render", _d]]), td = {}, id = { class: "icon icon-group-fill" };
function ad(n, c) {
  return s(), e("span", id);
}
const YM = /* @__PURE__ */ o(td, [["render", ad]]), dd = {}, fd = { class: "icon icon-group-regular" };
function ld(n, c) {
  return s(), e("span", fd);
}
const nP = /* @__PURE__ */ o(dd, [["render", ld]]), ud = {}, hd = { class: "icon icon-group_remove-fill" };
function $d(n, c) {
  return s(), e("span", hd);
}
const cP = /* @__PURE__ */ o(ud, [["render", $d]]), pd = {}, md = { class: "icon icon-group_remove-regular" };
function gd(n, c) {
  return s(), e("span", md);
}
const sP = /* @__PURE__ */ o(pd, [["render", gd]]), xd = {}, Id = { class: "icon icon-group_remove-thin" };
function Rd(n, c) {
  return s(), e("span", Id);
}
const eP = /* @__PURE__ */ o(xd, [["render", Rd]]), Td = {}, Fd = { class: "icon icon-groups-fill" };
function bd(n, c) {
  return s(), e("span", Fd);
}
const oP = /* @__PURE__ */ o(Td, [["render", bd]]), Cd = {}, wd = { class: "icon icon-groups-regular" };
function yd(n, c) {
  return s(), e("span", wd);
}
const rP = /* @__PURE__ */ o(Cd, [["render", yd]]), vd = {}, kd = { class: "icon icon-groups-thin" };
function Sd(n, c) {
  return s(), e("span", kd);
}
const _P = /* @__PURE__ */ o(vd, [["render", Sd]]), Dd = {}, Ad = { class: "icon icon-group-thin" };
function Md(n, c) {
  return s(), e("span", Ad);
}
const tP = /* @__PURE__ */ o(Dd, [["render", Md]]), Pd = {}, Bd = { class: "icon icon-reaction_sad-fill" };
function Ld(n, c) {
  return s(), e("span", Bd);
}
const iP = /* @__PURE__ */ o(Pd, [["render", Ld]]), Ud = {}, Gd = { class: "icon icon-reaction_sad-regular" };
function Wd(n, c) {
  return s(), e("span", Gd);
}
const aP = /* @__PURE__ */ o(Ud, [["render", Wd]]), Vd = {}, Hd = { class: "icon icon-reaction_sad-thin" };
function Ed(n, c) {
  return s(), e("span", Hd);
}
const dP = /* @__PURE__ */ o(Vd, [["render", Ed]]), zd = {}, qd = { class: "icon icon-reaction_smile-fill" };
function Nd(n, c) {
  return s(), e("span", qd);
}
const fP = /* @__PURE__ */ o(zd, [["render", Nd]]), Od = {}, Kd = { class: "icon icon-reaction_smile-regular" };
function Qd(n, c) {
  return s(), e("span", Kd);
}
const lP = /* @__PURE__ */ o(Od, [["render", Qd]]), Zd = {}, jd = { class: "icon icon-reaction_smile-thin" };
function Jd(n, c) {
  return s(), e("span", jd);
}
const uP = /* @__PURE__ */ o(Zd, [["render", Jd]]), Xd = {}, Yd = { class: "icon icon-user_add-fill" };
function nf(n, c) {
  return s(), e("span", Yd);
}
const hP = /* @__PURE__ */ o(Xd, [["render", nf]]), cf = {}, sf = { class: "icon icon-user_add-regular" };
function ef(n, c) {
  return s(), e("span", sf);
}
const $P = /* @__PURE__ */ o(cf, [["render", ef]]), of = {}, rf = { class: "icon icon-user_add-thin" };
function _f(n, c) {
  return s(), e("span", rf);
}
const pP = /* @__PURE__ */ o(of, [["render", _f]]), tf = {}, af = { class: "icon icon-user-fill" };
function df(n, c) {
  return s(), e("span", af);
}
const mP = /* @__PURE__ */ o(tf, [["render", df]]), ff = {}, lf = { class: "icon icon-user-regular" };
function uf(n, c) {
  return s(), e("span", lf);
}
const gP = /* @__PURE__ */ o(ff, [["render", uf]]), hf = {}, $f = { class: "icon icon-user_remove-fill" };
function pf(n, c) {
  return s(), e("span", $f);
}
const xP = /* @__PURE__ */ o(hf, [["render", pf]]), mf = {}, gf = { class: "icon icon-user_remove-regular" };
function xf(n, c) {
  return s(), e("span", gf);
}
const IP = /* @__PURE__ */ o(mf, [["render", xf]]), If = {}, Rf = { class: "icon icon-user_remove-thin" };
function Tf(n, c) {
  return s(), e("span", Rf);
}
const RP = /* @__PURE__ */ o(If, [["render", Tf]]), Ff = {}, bf = { class: "icon icon-user-thin" };
function Cf(n, c) {
  return s(), e("span", bf);
}
const TP = /* @__PURE__ */ o(Ff, [["render", Cf]]), wf = {}, yf = { class: "icon icon-ghost-fill" };
function vf(n, c) {
  return s(), e("span", yf);
}
const FP = /* @__PURE__ */ o(wf, [["render", vf]]), kf = {}, Sf = { class: "icon icon-ghost-regular" };
function Df(n, c) {
  return s(), e("span", Sf);
}
const bP = /* @__PURE__ */ o(kf, [["render", Df]]), Af = {}, Mf = { class: "icon icon-ghost-thin" };
function Pf(n, c) {
  return s(), e("span", Mf);
}
const CP = /* @__PURE__ */ o(Af, [["render", Pf]]), Bf = {}, Lf = { class: "icon icon-graduate-fill" };
function Uf(n, c) {
  return s(), e("span", Lf);
}
const wP = /* @__PURE__ */ o(Bf, [["render", Uf]]), Gf = {}, Wf = { class: "icon icon-graduate-regular" };
function Vf(n, c) {
  return s(), e("span", Wf);
}
const yP = /* @__PURE__ */ o(Gf, [["render", Vf]]), Hf = {}, Ef = { class: "icon icon-graduate-thin" };
function zf(n, c) {
  return s(), e("span", Ef);
}
const vP = /* @__PURE__ */ o(Hf, [["render", zf]]), qf = {}, Nf = { class: "icon icon-book-fill" };
function Of(n, c) {
  return s(), e("span", Nf);
}
const kP = /* @__PURE__ */ o(qf, [["render", Of]]), Kf = {}, Qf = { class: "icon icon-book-regular" };
function Zf(n, c) {
  return s(), e("span", Qf);
}
const SP = /* @__PURE__ */ o(Kf, [["render", Zf]]), jf = {}, Jf = { class: "icon icon-book-thin" };
function Xf(n, c) {
  return s(), e("span", Jf);
}
const DP = /* @__PURE__ */ o(jf, [["render", Xf]]), Yf = {}, nl = { class: "icon icon-cloud_download-fill" };
function cl(n, c) {
  return s(), e("span", nl);
}
const AP = /* @__PURE__ */ o(Yf, [["render", cl]]), sl = {}, el = { class: "icon icon-cloud_download-regular" };
function ol(n, c) {
  return s(), e("span", el);
}
const MP = /* @__PURE__ */ o(sl, [["render", ol]]), rl = {}, _l = { class: "icon icon-cloud_download-thin" };
function tl(n, c) {
  return s(), e("span", _l);
}
const PP = /* @__PURE__ */ o(rl, [["render", tl]]), il = {}, al = { class: "icon icon-cloud_upload-fill" };
function dl(n, c) {
  return s(), e("span", al);
}
const BP = /* @__PURE__ */ o(il, [["render", dl]]), fl = {}, ll = { class: "icon icon-cloud_upload-regular" };
function ul(n, c) {
  return s(), e("span", ll);
}
const LP = /* @__PURE__ */ o(fl, [["render", ul]]), hl = {}, $l = { class: "icon icon-cloud_upload-thin" };
function pl(n, c) {
  return s(), e("span", $l);
}
const UP = /* @__PURE__ */ o(hl, [["render", pl]]), ml = {}, gl = { class: "icon icon-cloud-fill" };
function xl(n, c) {
  return s(), e("span", gl);
}
const GP = /* @__PURE__ */ o(ml, [["render", xl]]), Il = {}, Rl = { class: "icon icon-cloud-regular" };
function Tl(n, c) {
  return s(), e("span", Rl);
}
const WP = /* @__PURE__ */ o(Il, [["render", Tl]]), Fl = {}, bl = { class: "icon icon-cloud-thin" };
function Cl(n, c) {
  return s(), e("span", bl);
}
const VP = /* @__PURE__ */ o(Fl, [["render", Cl]]), wl = {}, yl = { class: "icon icon-copy-fill" };
function vl(n, c) {
  return s(), e("span", yl);
}
const HP = /* @__PURE__ */ o(wl, [["render", vl]]), kl = {}, Sl = { class: "icon icon-copy-regular" };
function Dl(n, c) {
  return s(), e("span", Sl);
}
const EP = /* @__PURE__ */ o(kl, [["render", Dl]]), Al = {}, Ml = { class: "icon icon-copy-thin" };
function Pl(n, c) {
  return s(), e("span", Ml);
}
const zP = /* @__PURE__ */ o(Al, [["render", Pl]]), Bl = {}, Ll = { class: "icon icon-file_description-fill" };
function Ul(n, c) {
  return s(), e("span", Ll);
}
const qP = /* @__PURE__ */ o(Bl, [["render", Ul]]), Gl = {}, Wl = { class: "icon icon-file_description-regular" };
function Vl(n, c) {
  return s(), e("span", Wl);
}
const NP = /* @__PURE__ */ o(Gl, [["render", Vl]]), Hl = {}, El = { class: "icon icon-file_description-thin" };
function zl(n, c) {
  return s(), e("span", El);
}
const OP = /* @__PURE__ */ o(Hl, [["render", zl]]), ql = {}, Nl = { class: "icon icon-file-fill" };
function Ol(n, c) {
  return s(), e("span", Nl);
}
const KP = /* @__PURE__ */ o(ql, [["render", Ol]]), Kl = {}, Ql = { class: "icon icon-file-regular" };
function Zl(n, c) {
  return s(), e("span", Ql);
}
const QP = /* @__PURE__ */ o(Kl, [["render", Zl]]), jl = {}, Jl = { class: "icon icon-file-thin" };
function Xl(n, c) {
  return s(), e("span", Jl);
}
const ZP = /* @__PURE__ */ o(jl, [["render", Xl]]), Yl = {}, nu = { class: "icon icon-folder-fill" };
function cu(n, c) {
  return s(), e("span", nu);
}
const jP = /* @__PURE__ */ o(Yl, [["render", cu]]), su = {}, eu = { class: "icon icon-folder-regular" };
function ou(n, c) {
  return s(), e("span", eu);
}
const JP = /* @__PURE__ */ o(su, [["render", ou]]), ru = {}, _u = { class: "icon icon-folder-thin" };
function tu(n, c) {
  return s(), e("span", _u);
}
const XP = /* @__PURE__ */ o(ru, [["render", tu]]), iu = {}, au = { class: "icon icon-archive_download-regular" };
function du(n, c) {
  return s(), e("span", au);
}
const YP = /* @__PURE__ */ o(iu, [["render", du]]), fu = {}, lu = { class: "icon icon-archive_download-thin" };
function uu(n, c) {
  return s(), e("span", lu);
}
const nB = /* @__PURE__ */ o(fu, [["render", uu]]), hu = {}, $u = { class: "icon icon-archive_upload-regular" };
function pu(n, c) {
  return s(), e("span", $u);
}
const cB = /* @__PURE__ */ o(hu, [["render", pu]]), mu = {}, gu = { class: "icon icon-archive_upload-thin" };
function xu(n, c) {
  return s(), e("span", gu);
}
const sB = /* @__PURE__ */ o(mu, [["render", xu]]), Iu = {}, Ru = { class: "icon icon-archive-regular" };
function Tu(n, c) {
  return s(), e("span", Ru);
}
const eB = /* @__PURE__ */ o(Iu, [["render", Tu]]), Fu = {}, bu = { class: "icon icon-archive-thin" };
function Cu(n, c) {
  return s(), e("span", bu);
}
const oB = /* @__PURE__ */ o(Fu, [["render", Cu]]), wu = {}, yu = { class: "icon icon-bookmark_remove-regular" };
function vu(n, c) {
  return s(), e("span", yu);
}
const rB = /* @__PURE__ */ o(wu, [["render", vu]]), ku = {}, Su = { class: "icon icon-bookmark_remove-thin" };
function Du(n, c) {
  return s(), e("span", Su);
}
const _B = /* @__PURE__ */ o(ku, [["render", Du]]), Au = {}, Mu = { class: "icon icon-bookmark-regular" };
function Pu(n, c) {
  return s(), e("span", Mu);
}
const tB = /* @__PURE__ */ o(Au, [["render", Pu]]), Bu = {}, Lu = { class: "icon icon-bookmark-thin" };
function Uu(n, c) {
  return s(), e("span", Lu);
}
const iB = /* @__PURE__ */ o(Bu, [["render", Uu]]), Gu = {}, Wu = { class: "icon icon-clip-regular" };
function Vu(n, c) {
  return s(), e("span", Wu);
}
const aB = /* @__PURE__ */ o(Gu, [["render", Vu]]), Hu = {}, Eu = { class: "icon icon-clip-thin" };
function zu(n, c) {
  return s(), e("span", Eu);
}
const dB = /* @__PURE__ */ o(Hu, [["render", zu]]), qu = {}, Nu = { class: "icon icon-download-regular" };
function Ou(n, c) {
  return s(), e("span", Nu);
}
const fB = /* @__PURE__ */ o(qu, [["render", Ou]]), Ku = {}, Qu = { class: "icon icon-download-thin" };
function Zu(n, c) {
  return s(), e("span", Qu);
}
const lB = /* @__PURE__ */ o(Ku, [["render", Zu]]), ju = {}, Ju = { class: "icon icon-file_chart-regular" };
function Xu(n, c) {
  return s(), e("span", Ju);
}
const uB = /* @__PURE__ */ o(ju, [["render", Xu]]), Yu = {}, nh = { class: "icon icon-file_chart-thin" };
function ch(n, c) {
  return s(), e("span", nh);
}
const hB = /* @__PURE__ */ o(Yu, [["render", ch]]), sh = {}, eh = { class: "icon icon-file_add-regular" };
function oh(n, c) {
  return s(), e("span", eh);
}
const $B = /* @__PURE__ */ o(sh, [["render", oh]]), rh = {}, _h = { class: "icon icon-file_add-thin" };
function th(n, c) {
  return s(), e("span", _h);
}
const pB = /* @__PURE__ */ o(rh, [["render", th]]), ih = {}, ah = { class: "icon icon-file_copy-regular" };
function dh(n, c) {
  return s(), e("span", ah);
}
const mB = /* @__PURE__ */ o(ih, [["render", dh]]), fh = {}, lh = { class: "icon icon-file_copy-thin" };
function uh(n, c) {
  return s(), e("span", lh);
}
const gB = /* @__PURE__ */ o(fh, [["render", uh]]), hh = {}, $h = { class: "icon icon-file_download-regular" };
function ph(n, c) {
  return s(), e("span", $h);
}
const xB = /* @__PURE__ */ o(hh, [["render", ph]]), mh = {}, gh = { class: "icon icon-file_download-thin" };
function xh(n, c) {
  return s(), e("span", gh);
}
const IB = /* @__PURE__ */ o(mh, [["render", xh]]), Ih = {}, Rh = { class: "icon icon-file_pad-regular" };
function Th(n, c) {
  return s(), e("span", Rh);
}
const RB = /* @__PURE__ */ o(Ih, [["render", Th]]), Fh = {}, bh = { class: "icon icon-file_pad-thin" };
function Ch(n, c) {
  return s(), e("span", bh);
}
const TB = /* @__PURE__ */ o(Fh, [["render", Ch]]), wh = {}, yh = { class: "icon icon-file_remove-regular" };
function vh(n, c) {
  return s(), e("span", yh);
}
const FB = /* @__PURE__ */ o(wh, [["render", vh]]), kh = {}, Sh = { class: "icon icon-file_remove-thin" };
function Dh(n, c) {
  return s(), e("span", Sh);
}
const bB = /* @__PURE__ */ o(kh, [["render", Dh]]), Ah = {}, Mh = { class: "icon icon-file_upload-regular" };
function Ph(n, c) {
  return s(), e("span", Mh);
}
const CB = /* @__PURE__ */ o(Ah, [["render", Ph]]), Bh = {}, Lh = { class: "icon icon-file_upload-thin" };
function Uh(n, c) {
  return s(), e("span", Lh);
}
const wB = /* @__PURE__ */ o(Bh, [["render", Uh]]), Gh = {}, Wh = { class: "icon icon-folder_add-regular" };
function Vh(n, c) {
  return s(), e("span", Wh);
}
const yB = /* @__PURE__ */ o(Gh, [["render", Vh]]), Hh = {}, Eh = { class: "icon icon-folder_add-thin" };
function zh(n, c) {
  return s(), e("span", Eh);
}
const vB = /* @__PURE__ */ o(Hh, [["render", zh]]), qh = {}, Nh = { class: "icon icon-folder_download-regular" };
function Oh(n, c) {
  return s(), e("span", Nh);
}
const kB = /* @__PURE__ */ o(qh, [["render", Oh]]), Kh = {}, Qh = { class: "icon icon-folder_download-thin" };
function Zh(n, c) {
  return s(), e("span", Qh);
}
const SB = /* @__PURE__ */ o(Kh, [["render", Zh]]), jh = {}, Jh = { class: "icon icon-folder_remove-regular" };
function Xh(n, c) {
  return s(), e("span", Jh);
}
const DB = /* @__PURE__ */ o(jh, [["render", Xh]]), Yh = {}, n$ = { class: "icon icon-folder_remove-thin" };
function c$(n, c) {
  return s(), e("span", n$);
}
const AB = /* @__PURE__ */ o(Yh, [["render", c$]]), s$ = {}, e$ = { class: "icon icon-folder_upload-regular" };
function o$(n, c) {
  return s(), e("span", e$);
}
const MB = /* @__PURE__ */ o(s$, [["render", o$]]), r$ = {}, _$ = { class: "icon icon-folder_upload-thin" };
function t$(n, c) {
  return s(), e("span", _$);
}
const PB = /* @__PURE__ */ o(r$, [["render", t$]]), i$ = {}, a$ = { class: "icon icon-note_edit-regular" };
function d$(n, c) {
  return s(), e("span", a$);
}
const BB = /* @__PURE__ */ o(i$, [["render", d$]]), f$ = {}, l$ = { class: "icon icon-note_edit-thin" };
function u$(n, c) {
  return s(), e("span", l$);
}
const LB = /* @__PURE__ */ o(f$, [["render", u$]]), h$ = {}, $$ = { class: "icon icon-note_edit-fill" };
function p$(n, c) {
  return s(), e("span", $$);
}
const UB = /* @__PURE__ */ o(h$, [["render", p$]]), m$ = {}, g$ = { class: "icon icon-pad-regular" };
function x$(n, c) {
  return s(), e("span", g$);
}
const GB = /* @__PURE__ */ o(m$, [["render", x$]]), I$ = {}, R$ = { class: "icon icon-pad-thin" };
function T$(n, c) {
  return s(), e("span", R$);
}
const WB = /* @__PURE__ */ o(I$, [["render", T$]]), F$ = {}, b$ = { class: "icon icon-sticker-regular" };
function C$(n, c) {
  return s(), e("span", b$);
}
const VB = /* @__PURE__ */ o(F$, [["render", C$]]), w$ = {}, y$ = { class: "icon icon-sticker-thin" };
function v$(n, c) {
  return s(), e("span", y$);
}
const HB = /* @__PURE__ */ o(w$, [["render", v$]]), k$ = {}, S$ = { class: "icon icon-upload-regular" };
function D$(n, c) {
  return s(), e("span", S$);
}
const EB = /* @__PURE__ */ o(k$, [["render", D$]]), A$ = {}, M$ = { class: "icon icon-upload-thin" };
function P$(n, c) {
  return s(), e("span", M$);
}
const zB = /* @__PURE__ */ o(A$, [["render", P$]]), B$ = {}, L$ = { class: "icon icon-circle-regular" };
function U$(n, c) {
  return s(), e("span", L$);
}
const qB = /* @__PURE__ */ o(B$, [["render", U$]]), G$ = {}, W$ = { class: "icon icon-circle-thin" };
function V$(n, c) {
  return s(), e("span", W$);
}
const NB = /* @__PURE__ */ o(G$, [["render", V$]]), H$ = {}, E$ = { class: "icon icon-circle-fill" };
function z$(n, c) {
  return s(), e("span", E$);
}
const OB = /* @__PURE__ */ o(H$, [["render", z$]]), q$ = {}, N$ = { class: "icon icon-placeholder-regular" };
function O$(n, c) {
  return s(), e("span", N$);
}
const KB = /* @__PURE__ */ o(q$, [["render", O$]]), K$ = {}, Q$ = { class: "icon icon-placeholder-thin" };
function Z$(n, c) {
  return s(), e("span", Q$);
}
const QB = /* @__PURE__ */ o(K$, [["render", Z$]]), j$ = {}, J$ = { class: "icon icon-shield-regular" };
function X$(n, c) {
  return s(), e("span", J$);
}
const ZB = /* @__PURE__ */ o(j$, [["render", X$]]), Y$ = {}, np = { class: "icon icon-shield-thin" };
function cp(n, c) {
  return s(), e("span", np);
}
const jB = /* @__PURE__ */ o(Y$, [["render", cp]]), sp = {}, ep = { class: "icon icon-shield-fill" };
function op(n, c) {
  return s(), e("span", ep);
}
const JB = /* @__PURE__ */ o(sp, [["render", op]]), rp = {}, _p = { class: "icon icon-square-regular" };
function tp(n, c) {
  return s(), e("span", _p);
}
const XB = /* @__PURE__ */ o(rp, [["render", tp]]), ip = {}, ap = { class: "icon icon-square-thin" };
function dp(n, c) {
  return s(), e("span", ap);
}
const YB = /* @__PURE__ */ o(ip, [["render", dp]]), fp = {}, lp = { class: "icon icon-triangle-regular" };
function up(n, c) {
  return s(), e("span", lp);
}
const nL = /* @__PURE__ */ o(fp, [["render", up]]), hp = {}, $p = { class: "icon icon-triangle-thin" };
function pp(n, c) {
  return s(), e("span", $p);
}
const cL = /* @__PURE__ */ o(hp, [["render", pp]]), mp = {}, gp = { class: "icon icon-wavy-regular" };
function xp(n, c) {
  return s(), e("span", gp);
}
const sL = /* @__PURE__ */ o(mp, [["render", xp]]), Ip = {}, Rp = { class: "icon icon-wavy-thin" };
function Tp(n, c) {
  return s(), e("span", Rp);
}
const eL = /* @__PURE__ */ o(Ip, [["render", Tp]]), Fp = {}, bp = { class: "icon icon-notification-thin" };
function Cp(n, c) {
  return s(), e("span", bp);
}
const oL = /* @__PURE__ */ o(Fp, [["render", Cp]]), wp = {}, yp = { class: "icon icon-notification_remove-regular" };
function vp(n, c) {
  return s(), e("span", yp);
}
const rL = /* @__PURE__ */ o(wp, [["render", vp]]), kp = {}, Sp = { class: "icon icon-notification_remove-thin" };
function Dp(n, c) {
  return s(), e("span", Sp);
}
const _L = /* @__PURE__ */ o(kp, [["render", Dp]]), Ap = {}, Mp = { class: "icon icon-notification-regular" };
function Pp(n, c) {
  return s(), e("span", Mp);
}
const tL = /* @__PURE__ */ o(Ap, [["render", Pp]]), Bp = {}, Lp = { class: "icon icon-notification-fill" };
function Up(n, c) {
  return s(), e("span", Lp);
}
const iL = /* @__PURE__ */ o(Bp, [["render", Up]]), Gp = {}, Wp = { class: "icon icon-filter_arrow_down-regular" };
function Vp(n, c) {
  return s(), e("span", Wp);
}
const aL = /* @__PURE__ */ o(Gp, [["render", Vp]]), Hp = {}, Ep = { class: "icon icon-filter_arrow_down-thin" };
function zp(n, c) {
  return s(), e("span", Ep);
}
const dL = /* @__PURE__ */ o(Hp, [["render", zp]]), qp = {}, Np = { class: "icon icon-filter_arrow_up-regular" };
function Op(n, c) {
  return s(), e("span", Np);
}
const fL = /* @__PURE__ */ o(qp, [["render", Op]]), Kp = {}, Qp = { class: "icon icon-filter_arrow_up-thin" };
function Zp(n, c) {
  return s(), e("span", Qp);
}
const lL = /* @__PURE__ */ o(Kp, [["render", Zp]]), jp = {}, Jp = { class: "icon icon-table_add-regular" };
function Xp(n, c) {
  return s(), e("span", Jp);
}
const uL = /* @__PURE__ */ o(jp, [["render", Xp]]), Yp = {}, nm = { class: "icon icon-table_add-thin" };
function cm(n, c) {
  return s(), e("span", nm);
}
const hL = /* @__PURE__ */ o(Yp, [["render", cm]]), sm = {}, em = { class: "icon icon-table_remove-regular" };
function om(n, c) {
  return s(), e("span", em);
}
const $L = /* @__PURE__ */ o(sm, [["render", om]]), rm = {}, _m = { class: "icon icon-table_remove-thin" };
function tm(n, c) {
  return s(), e("span", _m);
}
const pL = /* @__PURE__ */ o(rm, [["render", tm]]), im = {}, am = { class: "icon icon-table-regular" };
function dm(n, c) {
  return s(), e("span", am);
}
const mL = /* @__PURE__ */ o(im, [["render", dm]]), fm = {}, lm = { class: "icon icon-table-thin" };
function um(n, c) {
  return s(), e("span", lm);
}
const gL = /* @__PURE__ */ o(fm, [["render", um]]), hm = {}, $m = { class: "icon icon-toolbar-regular" };
function pm(n, c) {
  return s(), e("span", $m);
}
const xL = /* @__PURE__ */ o(hm, [["render", pm]]), mm = {}, gm = { class: "icon icon-toolbar-thin" };
function xm(n, c) {
  return s(), e("span", gm);
}
const IL = /* @__PURE__ */ o(mm, [["render", xm]]), Im = {}, Rm = { class: "icon icon-format_center-regular" };
function Tm(n, c) {
  return s(), e("span", Rm);
}
const RL = /* @__PURE__ */ o(Im, [["render", Tm]]), Fm = {}, bm = { class: "icon icon-format_center-thin" };
function Cm(n, c) {
  return s(), e("span", bm);
}
const TL = /* @__PURE__ */ o(Fm, [["render", Cm]]), wm = {}, ym = { class: "icon icon-format_justify-regular" };
function vm(n, c) {
  return s(), e("span", ym);
}
const FL = /* @__PURE__ */ o(wm, [["render", vm]]), km = {}, Sm = { class: "icon icon-format_justify-thin" };
function Dm(n, c) {
  return s(), e("span", Sm);
}
const bL = /* @__PURE__ */ o(km, [["render", Dm]]), Am = {}, Mm = { class: "icon icon-format_left-regular" };
function Pm(n, c) {
  return s(), e("span", Mm);
}
const CL = /* @__PURE__ */ o(Am, [["render", Pm]]), Bm = {}, Lm = { class: "icon icon-format_left-thin" };
function Um(n, c) {
  return s(), e("span", Lm);
}
const wL = /* @__PURE__ */ o(Bm, [["render", Um]]), Gm = {}, Wm = { class: "icon icon-format_right-regular" };
function Vm(n, c) {
  return s(), e("span", Wm);
}
const yL = /* @__PURE__ */ o(Gm, [["render", Vm]]), Hm = {}, Em = { class: "icon icon-format_right-thin" };
function zm(n, c) {
  return s(), e("span", Em);
}
const vL = /* @__PURE__ */ o(Hm, [["render", zm]]), qm = {}, Nm = { class: "icon icon-list-regular" };
function Om(n, c) {
  return s(), e("span", Nm);
}
const kL = /* @__PURE__ */ o(qm, [["render", Om]]), Km = {}, Qm = { class: "icon icon-list-thin" };
function Zm(n, c) {
  return s(), e("span", Qm);
}
const SL = /* @__PURE__ */ o(Km, [["render", Zm]]), jm = {}, Jm = { class: "icon icon-translate-regular" };
function Xm(n, c) {
  return s(), e("span", Jm);
}
const DL = /* @__PURE__ */ o(jm, [["render", Xm]]), Ym = {}, n1 = { class: "icon icon-translate-thin" };
function c1(n, c) {
  return s(), e("span", n1);
}
const AL = /* @__PURE__ */ o(Ym, [["render", c1]]), s1 = {}, e1 = { class: "icon icon-at-symbol-regular" };
function o1(n, c) {
  return s(), e("span", e1);
}
const ML = /* @__PURE__ */ o(s1, [["render", o1]]), r1 = {}, _1 = { class: "icon icon-at-symbol-thin" };
function t1(n, c) {
  return s(), e("span", _1);
}
const PL = /* @__PURE__ */ o(r1, [["render", t1]]), i1 = {}, a1 = { class: "icon icon-bold-regular" };
function d1(n, c) {
  return s(), e("span", a1);
}
const BL = /* @__PURE__ */ o(i1, [["render", d1]]), f1 = {}, l1 = { class: "icon icon-bold-thin" };
function u1(n, c) {
  return s(), e("span", l1);
}
const LL = /* @__PURE__ */ o(f1, [["render", u1]]), h1 = {}, $1 = { class: "icon icon-underline-regular" };
function p1(n, c) {
  return s(), e("span", $1);
}
const UL = /* @__PURE__ */ o(h1, [["render", p1]]), m1 = {}, g1 = { class: "icon icon-underline-thin" };
function x1(n, c) {
  return s(), e("span", g1);
}
const GL = /* @__PURE__ */ o(m1, [["render", x1]]), I1 = {}, R1 = { class: "icon icon-list_numbered-regular" };
function T1(n, c) {
  return s(), e("span", R1);
}
const WL = /* @__PURE__ */ o(I1, [["render", T1]]), F1 = {}, b1 = { class: "icon icon-list_numbered-thin" };
function C1(n, c) {
  return s(), e("span", b1);
}
const VL = /* @__PURE__ */ o(F1, [["render", C1]]), w1 = {}, y1 = { class: "icon icon-filter-fill" };
function v1(n, c) {
  return s(), e("span", y1);
}
const HL = /* @__PURE__ */ o(w1, [["render", v1]]), k1 = {}, S1 = { class: "icon icon-filter-regular" };
function D1(n, c) {
  return s(), e("span", S1);
}
const EL = /* @__PURE__ */ o(k1, [["render", D1]]), A1 = {}, M1 = { class: "icon icon-filter-thin" };
function P1(n, c) {
  return s(), e("span", M1);
}
const zL = /* @__PURE__ */ o(A1, [["render", P1]]), B1 = {}, L1 = { class: "icon icon-settings-fill" };
function U1(n, c) {
  return s(), e("span", L1);
}
const qL = /* @__PURE__ */ o(B1, [["render", U1]]), G1 = {}, W1 = { class: "icon icon-settings-regular" };
function V1(n, c) {
  return s(), e("span", W1);
}
const NL = /* @__PURE__ */ o(G1, [["render", V1]]), H1 = {}, E1 = { class: "icon icon-settings-thin" };
function z1(n, c) {
  return s(), e("span", E1);
}
const OL = /* @__PURE__ */ o(H1, [["render", z1]]), q1 = {}, N1 = { class: "icon icon-slider_horizont-regular" };
function O1(n, c) {
  return s(), e("span", N1);
}
const KL = /* @__PURE__ */ o(q1, [["render", O1]]), K1 = {}, Q1 = { class: "icon icon-slider_horizont-thin" };
function Z1(n, c) {
  return s(), e("span", Q1);
}
const QL = /* @__PURE__ */ o(K1, [["render", Z1]]), j1 = {}, J1 = { class: "icon icon-slider_vert-regular" };
function X1(n, c) {
  return s(), e("span", J1);
}
const ZL = /* @__PURE__ */ o(j1, [["render", X1]]), Y1 = {}, ng = { class: "icon icon-slider_vert-thin" };
function cg(n, c) {
  return s(), e("span", ng);
}
const jL = /* @__PURE__ */ o(Y1, [["render", cg]]), sg = {}, eg = { class: "icon icon-wrench-sc-regular" };
function og(n, c) {
  return s(), e("span", eg);
}
const JL = /* @__PURE__ */ o(sg, [["render", og]]), rg = {}, _g = { class: "icon icon-wrench-sc-thin" };
function tg(n, c) {
  return s(), e("span", _g);
}
const XL = /* @__PURE__ */ o(rg, [["render", tg]]), ig = {}, ag = { class: "icon icon-wrench-fill" };
function dg(n, c) {
  return s(), e("span", ag);
}
const YL = /* @__PURE__ */ o(ig, [["render", dg]]), fg = {}, lg = { class: "icon icon-wrench-regular" };
function ug(n, c) {
  return s(), e("span", lg);
}
const nU = /* @__PURE__ */ o(fg, [["render", ug]]), hg = {}, $g = { class: "icon icon-wrench-thin" };
function pg(n, c) {
  return s(), e("span", $g);
}
const cU = /* @__PURE__ */ o(hg, [["render", pg]]), mg = {}, gg = { class: "icon icon-message-fill" };
function xg(n, c) {
  return s(), e("span", gg);
}
const sU = /* @__PURE__ */ o(mg, [["render", xg]]), Ig = {}, Rg = { class: "icon icon-message-regular" };
function Tg(n, c) {
  return s(), e("span", Rg);
}
const eU = /* @__PURE__ */ o(Ig, [["render", Tg]]), Fg = {}, bg = { class: "icon icon-message-thin" };
function Cg(n, c) {
  return s(), e("span", bg);
}
const oU = /* @__PURE__ */ o(Fg, [["render", Cg]]), wg = {}, yg = { class: "icon icon-send-regular" };
function vg(n, c) {
  return s(), e("span", yg);
}
const rU = /* @__PURE__ */ o(wg, [["render", vg]]), kg = {}, Sg = { class: "icon icon-send-thin" };
function Dg(n, c) {
  return s(), e("span", Sg);
}
const _U = /* @__PURE__ */ o(kg, [["render", Dg]]), Ag = {}, Mg = { class: "icon icon-mail-fill" };
function Pg(n, c) {
  return s(), e("span", Mg);
}
const tU = /* @__PURE__ */ o(Ag, [["render", Pg]]), Bg = {}, Lg = { class: "icon icon-mail-regular" };
function Ug(n, c) {
  return s(), e("span", Lg);
}
const iU = /* @__PURE__ */ o(Bg, [["render", Ug]]), Gg = {}, Wg = { class: "icon icon-mail-thin" };
function Vg(n, c) {
  return s(), e("span", Wg);
}
const aU = /* @__PURE__ */ o(Gg, [["render", Vg]]), Hg = {}, Eg = { class: "icon icon-phone-fill" };
function zg(n, c) {
  return s(), e("span", Eg);
}
const dU = /* @__PURE__ */ o(Hg, [["render", zg]]), qg = {}, Ng = { class: "icon icon-phone-regular" };
function Og(n, c) {
  return s(), e("span", Ng);
}
const fU = /* @__PURE__ */ o(qg, [["render", Og]]), Kg = {}, Qg = { class: "icon icon-phone-thin" };
function Zg(n, c) {
  return s(), e("span", Qg);
}
const lU = /* @__PURE__ */ o(Kg, [["render", Zg]]), jg = {}, Jg = { class: "icon icon-message_dots-fill" };
function Xg(n, c) {
  return s(), e("span", Jg);
}
const uU = /* @__PURE__ */ o(jg, [["render", Xg]]), Yg = {}, nx = { class: "icon icon-message_dots-regular" };
function cx(n, c) {
  return s(), e("span", nx);
}
const hU = /* @__PURE__ */ o(Yg, [["render", cx]]), sx = {}, ex = { class: "icon icon-message_dots-thin" };
function ox(n, c) {
  return s(), e("span", ex);
}
const $U = /* @__PURE__ */ o(sx, [["render", ox]]), rx = {}, _x = { class: "icon icon-message_comments-fill" };
function tx(n, c) {
  return s(), e("span", _x);
}
const pU = /* @__PURE__ */ o(rx, [["render", tx]]), ix = {}, ax = { class: "icon icon-message_comments-regular" };
function dx(n, c) {
  return s(), e("span", ax);
}
const mU = /* @__PURE__ */ o(ix, [["render", dx]]), fx = {}, lx = { class: "icon icon-message_comments-thin" };
function ux(n, c) {
  return s(), e("span", lx);
}
const gU = /* @__PURE__ */ o(fx, [["render", ux]]), hx = {}, $x = { class: "icon icon-binar_left-regular" };
function px(n, c) {
  return s(), e("span", $x);
}
const xU = /* @__PURE__ */ o(hx, [["render", px]]), mx = {}, gx = { class: "icon icon-binar_left-thin" };
function xx(n, c) {
  return s(), e("span", gx);
}
const IU = /* @__PURE__ */ o(mx, [["render", xx]]), Ix = {}, Rx = { class: "icon icon-binar-regular" };
function Tx(n, c) {
  return s(), e("span", Rx);
}
const RU = /* @__PURE__ */ o(Ix, [["render", Tx]]), Fx = {}, bx = { class: "icon icon-binar_right-regular" };
function Cx(n, c) {
  return s(), e("span", bx);
}
const TU = /* @__PURE__ */ o(Fx, [["render", Cx]]), wx = {}, yx = { class: "icon icon-binar_right-thin" };
function vx(n, c) {
  return s(), e("span", yx);
}
const FU = /* @__PURE__ */ o(wx, [["render", vx]]), kx = {}, Sx = { class: "icon icon-binar-thin" };
function Dx(n, c) {
  return s(), e("span", Sx);
}
const bU = /* @__PURE__ */ o(kx, [["render", Dx]]), Ax = {}, Mx = { class: "icon icon-binar_top-regular" };
function Px(n, c) {
  return s(), e("span", Mx);
}
const CU = /* @__PURE__ */ o(Ax, [["render", Px]]), Bx = {}, Lx = { class: "icon icon-binar_top-thin" };
function Ux(n, c) {
  return s(), e("span", Lx);
}
const wU = /* @__PURE__ */ o(Bx, [["render", Ux]]), Gx = {}, Wx = { class: "icon icon-chart_bar-fill" };
function Vx(n, c) {
  return s(), e("span", Wx);
}
const yU = /* @__PURE__ */ o(Gx, [["render", Vx]]), Hx = {}, Ex = { class: "icon icon-chart_bar-regular" };
function zx(n, c) {
  return s(), e("span", Ex);
}
const vU = /* @__PURE__ */ o(Hx, [["render", zx]]), qx = {}, Nx = { class: "icon icon-chart_bar-thin" };
function Ox(n, c) {
  return s(), e("span", Nx);
}
const kU = /* @__PURE__ */ o(qx, [["render", Ox]]), Kx = {}, Qx = { class: "icon icon-chart_diagram_up-regular" };
function Zx(n, c) {
  return s(), e("span", Qx);
}
const SU = /* @__PURE__ */ o(Kx, [["render", Zx]]), jx = {}, Jx = { class: "icon icon-chart_diagram_up-thin" };
function Xx(n, c) {
  return s(), e("span", Jx);
}
const DU = /* @__PURE__ */ o(jx, [["render", Xx]]), Yx = {}, nI = { class: "icon icon-chart_pie-regular" };
function cI(n, c) {
  return s(), e("span", nI);
}
const AU = /* @__PURE__ */ o(Yx, [["render", cI]]), sI = {}, eI = { class: "icon icon-chart_pie-thin" };
function oI(n, c) {
  return s(), e("span", eI);
}
const MU = /* @__PURE__ */ o(sI, [["render", oI]]), rI = {}, _I = { class: "icon icon-graph_down-regular" };
function tI(n, c) {
  return s(), e("span", _I);
}
const PU = /* @__PURE__ */ o(rI, [["render", tI]]), iI = {}, aI = { class: "icon icon-graph_down-thin" };
function dI(n, c) {
  return s(), e("span", aI);
}
const BU = /* @__PURE__ */ o(iI, [["render", dI]]), fI = {}, lI = { class: "icon icon-graph_up-regular" };
function uI(n, c) {
  return s(), e("span", lI);
}
const LU = /* @__PURE__ */ o(fI, [["render", uI]]), hI = {}, $I = { class: "icon icon-graph_up-thin" };
function pI(n, c) {
  return s(), e("span", $I);
}
const UU = /* @__PURE__ */ o(hI, [["render", pI]]), mI = {}, gI = { class: "icon icon-linear-regular" };
function xI(n, c) {
  return s(), e("span", gI);
}
const GU = /* @__PURE__ */ o(mI, [["render", xI]]), II = {}, RI = { class: "icon icon-linear-thin" };
function TI(n, c) {
  return s(), e("span", RI);
}
const WU = /* @__PURE__ */ o(II, [["render", TI]]), FI = {}, bI = { class: "icon icon-rfm-statistic-regular" };
function CI(n, c) {
  return s(), e("span", bI);
}
const VU = /* @__PURE__ */ o(FI, [["render", CI]]), wI = {}, yI = { class: "icon icon-rfm-statistic-thin" };
function vI(n, c) {
  return s(), e("span", yI);
}
const HU = /* @__PURE__ */ o(wI, [["render", vI]]), kI = {}, SI = { class: "icon icon-home-fill" };
function DI(n, c) {
  return s(), e("span", SI);
}
const EU = /* @__PURE__ */ o(kI, [["render", DI]]), AI = {}, MI = { class: "icon icon-home-regular" };
function PI(n, c) {
  return s(), e("span", MI);
}
const zU = /* @__PURE__ */ o(AI, [["render", PI]]), BI = {}, LI = { class: "icon icon-home-thin" };
function UI(n, c) {
  return s(), e("span", LI);
}
const qU = /* @__PURE__ */ o(BI, [["render", UI]]), GI = {}, WI = { class: "icon icon-map-fill" };
function VI(n, c) {
  return s(), e("span", WI);
}
const NU = /* @__PURE__ */ o(GI, [["render", VI]]), HI = {}, EI = { class: "icon icon-map-regular" };
function zI(n, c) {
  return s(), e("span", EI);
}
const OU = /* @__PURE__ */ o(HI, [["render", zI]]), qI = {}, NI = { class: "icon icon-map-thin" };
function OI(n, c) {
  return s(), e("span", NI);
}
const KU = /* @__PURE__ */ o(qI, [["render", OI]]), KI = {}, QI = { class: "icon icon-map_pin-fill" };
function ZI(n, c) {
  return s(), e("span", QI);
}
const QU = /* @__PURE__ */ o(KI, [["render", ZI]]), jI = {}, JI = { class: "icon icon-map_pin-regular" };
function XI(n, c) {
  return s(), e("span", JI);
}
const ZU = /* @__PURE__ */ o(jI, [["render", XI]]), YI = {}, nR = { class: "icon icon-map_pin-thin" };
function cR(n, c) {
  return s(), e("span", nR);
}
const jU = /* @__PURE__ */ o(YI, [["render", cR]]), sR = {}, eR = { class: "icon icon-parking-fill" };
function oR(n, c) {
  return s(), e("span", eR);
}
const JU = /* @__PURE__ */ o(sR, [["render", oR]]), rR = {}, _R = { class: "icon icon-parking-regular" };
function tR(n, c) {
  return s(), e("span", _R);
}
const XU = /* @__PURE__ */ o(rR, [["render", tR]]), iR = {}, aR = { class: "icon icon-tsp-thin" };
function dR(n, c) {
  return s(), e("span", aR);
}
const YU = /* @__PURE__ */ o(iR, [["render", dR]]), fR = {}, lR = { class: "icon icon-navigation-regular" };
function uR(n, c) {
  return s(), e("span", lR);
}
const nG = /* @__PURE__ */ o(fR, [["render", uR]]), hR = {}, $R = { class: "icon icon-navigation-thin" };
function pR(n, c) {
  return s(), e("span", $R);
}
const cG = /* @__PURE__ */ o(hR, [["render", pR]]), mR = {}, gR = { class: "icon icon-globe-regular" };
function xR(n, c) {
  return s(), e("span", gR);
}
const sG = /* @__PURE__ */ o(mR, [["render", xR]]), IR = {}, RR = { class: "icon icon-globe-thin" };
function TR(n, c) {
  return s(), e("span", RR);
}
const eG = /* @__PURE__ */ o(IR, [["render", TR]]), FR = {}, bR = { class: "icon icon-building-regular" };
function CR(n, c) {
  return s(), e("span", bR);
}
const oG = /* @__PURE__ */ o(FR, [["render", CR]]), wR = {}, yR = { class: "icon icon-building-thin" };
function vR(n, c) {
  return s(), e("span", yR);
}
const rG = /* @__PURE__ */ o(wR, [["render", vR]]), kR = {}, SR = { class: "icon icon-world-regular" };
function DR(n, c) {
  return s(), e("span", SR);
}
const _G = /* @__PURE__ */ o(kR, [["render", DR]]), AR = {}, MR = { class: "icon icon-world-thin" };
function PR(n, c) {
  return s(), e("span", MR);
}
const tG = /* @__PURE__ */ o(AR, [["render", PR]]), BR = {}, LR = { class: "icon icon-tsp-fill" };
function UR(n, c) {
  return s(), e("span", LR);
}
const iG = /* @__PURE__ */ o(BR, [["render", UR]]), GR = {}, WR = { class: "icon icon-tsp-regular" };
function VR(n, c) {
  return s(), e("span", WR);
}
const aG = /* @__PURE__ */ o(GR, [["render", VR]]), HR = {}, ER = { class: "icon icon-tsp-thin" };
function zR(n, c) {
  return s(), e("span", ER);
}
const dG = /* @__PURE__ */ o(HR, [["render", zR]]), qR = {}, NR = { class: "icon icon-more_vert-regular" };
function OR(n, c) {
  return s(), e("span", NR);
}
const fG = /* @__PURE__ */ o(qR, [["render", OR]]), KR = {}, QR = { class: "icon icon-more_vert-thin" };
function ZR(n, c) {
  return s(), e("span", QR);
}
const lG = /* @__PURE__ */ o(KR, [["render", ZR]]), jR = {}, JR = { class: "icon icon-panel_open-regular" };
function XR(n, c) {
  return s(), e("span", JR);
}
const uG = /* @__PURE__ */ o(jR, [["render", XR]]), YR = {}, nT = { class: "icon icon-panel_open-thin" };
function cT(n, c) {
  return s(), e("span", nT);
}
const hG = /* @__PURE__ */ o(YR, [["render", cT]]), sT = {}, eT = { class: "icon icon-panel_close-regular" };
function oT(n, c) {
  return s(), e("span", eT);
}
const $G = /* @__PURE__ */ o(sT, [["render", oT]]), rT = {}, _T = { class: "icon icon-panel_close-thin" };
function tT(n, c) {
  return s(), e("span", _T);
}
const pG = /* @__PURE__ */ o(rT, [["render", tT]]), iT = {}, aT = { class: "icon icon-login-regular" };
function dT(n, c) {
  return s(), e("span", aT);
}
const mG = /* @__PURE__ */ o(iT, [["render", dT]]), fT = {}, lT = { class: "icon icon-login-thin" };
function uT(n, c) {
  return s(), e("span", lT);
}
const gG = /* @__PURE__ */ o(fT, [["render", uT]]), hT = {}, $T = { class: "icon icon-exit-regular" };
function pT(n, c) {
  return s(), e("span", $T);
}
const xG = /* @__PURE__ */ o(hT, [["render", pT]]), mT = {}, gT = { class: "icon icon-exit-thin" };
function xT(n, c) {
  return s(), e("span", gT);
}
const IG = /* @__PURE__ */ o(mT, [["render", xT]]), IT = {}, RT = { class: "icon icon-close-regular" };
function TT(n, c) {
  return s(), e("span", RT);
}
const RG = /* @__PURE__ */ o(IT, [["render", TT]]), FT = {}, bT = { class: "icon icon-close-thin" };
function CT(n, c) {
  return s(), e("span", bT);
}
const TG = /* @__PURE__ */ o(FT, [["render", CT]]), wT = {}, yT = { class: "icon icon-burger-regular" };
function vT(n, c) {
  return s(), e("span", yT);
}
const FG = /* @__PURE__ */ o(wT, [["render", vT]]), kT = {}, ST = { class: "icon icon-burger-thin" };
function DT(n, c) {
  return s(), e("span", ST);
}
const bG = /* @__PURE__ */ o(kT, [["render", DT]]), AT = {}, MT = { class: "icon icon-more_grid_l-regular" };
function PT(n, c) {
  return s(), e("span", MT);
}
const CG = /* @__PURE__ */ o(AT, [["render", PT]]), BT = {}, LT = { class: "icon icon-more_grid_l-thin" };
function UT(n, c) {
  return s(), e("span", LT);
}
const wG = /* @__PURE__ */ o(BT, [["render", UT]]), GT = {}, WT = { class: "icon icon-more_grid_m-regular" };
function VT(n, c) {
  return s(), e("span", WT);
}
const yG = /* @__PURE__ */ o(GT, [["render", VT]]), HT = {}, ET = { class: "icon icon-more_grid_m-thin" };
function zT(n, c) {
  return s(), e("span", ET);
}
const vG = /* @__PURE__ */ o(HT, [["render", zT]]), qT = {}, NT = { class: "icon icon-more_grid_s-regular" };
function OT(n, c) {
  return s(), e("span", NT);
}
const kG = /* @__PURE__ */ o(qT, [["render", OT]]), KT = {}, QT = { class: "icon icon-more_grid_s-thin" };
function ZT(n, c) {
  return s(), e("span", QT);
}
const SG = /* @__PURE__ */ o(KT, [["render", ZT]]), jT = {}, JT = { class: "icon icon-more_horizont-regular" };
function XT(n, c) {
  return s(), e("span", JT);
}
const DG = /* @__PURE__ */ o(jT, [["render", XT]]), YT = {}, n2 = { class: "icon icon-more_horizont-thin" };
function c2(n, c) {
  return s(), e("span", n2);
}
const AG = /* @__PURE__ */ o(YT, [["render", c2]]), s2 = {}, e2 = { class: "icon icon-widget_add-fill" };
function o2(n, c) {
  return s(), e("span", e2);
}
const MG = /* @__PURE__ */ o(s2, [["render", o2]]), r2 = {}, _2 = { class: "icon icon-widget_add-regular" };
function t2(n, c) {
  return s(), e("span", _2);
}
const PG = /* @__PURE__ */ o(r2, [["render", t2]]), i2 = {}, a2 = { class: "icon icon-widget_add-thin" };
function d2(n, c) {
  return s(), e("span", a2);
}
const BG = /* @__PURE__ */ o(i2, [["render", d2]]), f2 = {}, l2 = { class: "icon icon-widget-fill" };
function u2(n, c) {
  return s(), e("span", l2);
}
const LG = /* @__PURE__ */ o(f2, [["render", u2]]), h2 = {}, $2 = { class: "icon icon-widget-regular" };
function p2(n, c) {
  return s(), e("span", $2);
}
const UG = /* @__PURE__ */ o(h2, [["render", p2]]), m2 = {}, g2 = { class: "icon icon-widget-thin" };
function x2(n, c) {
  return s(), e("span", g2);
}
const GG = /* @__PURE__ */ o(m2, [["render", x2]]), I2 = {}, R2 = { class: "icon icon-qrcode-fill" };
function T2(n, c) {
  return s(), e("span", R2);
}
const WG = /* @__PURE__ */ o(I2, [["render", T2]]), F2 = {}, b2 = { class: "icon icon-qrcode-regular" };
function C2(n, c) {
  return s(), e("span", b2);
}
const VG = /* @__PURE__ */ o(F2, [["render", C2]]), w2 = {}, y2 = { class: "icon icon-qrcode-thin" };
function v2(n, c) {
  return s(), e("span", y2);
}
const HG = /* @__PURE__ */ o(w2, [["render", v2]]), k2 = {}, S2 = { class: "icon icon-cart-fill" };
function D2(n, c) {
  return s(), e("span", S2);
}
const EG = /* @__PURE__ */ o(k2, [["render", D2]]), A2 = {}, M2 = { class: "icon icon-cart-regular" };
function P2(n, c) {
  return s(), e("span", M2);
}
const zG = /* @__PURE__ */ o(A2, [["render", P2]]), B2 = {}, L2 = { class: "icon icon-cart-thin" };
function U2(n, c) {
  return s(), e("span", L2);
}
const qG = /* @__PURE__ */ o(B2, [["render", U2]]), G2 = {}, W2 = { class: "icon icon-bag-fill" };
function V2(n, c) {
  return s(), e("span", W2);
}
const NG = /* @__PURE__ */ o(G2, [["render", V2]]), H2 = {}, E2 = { class: "icon icon-bag-regular" };
function z2(n, c) {
  return s(), e("span", E2);
}
const OG = /* @__PURE__ */ o(H2, [["render", z2]]), q2 = {}, N2 = { class: "icon icon-bag-thin" };
function O2(n, c) {
  return s(), e("span", N2);
}
const KG = /* @__PURE__ */ o(q2, [["render", O2]]), K2 = {}, Q2 = { class: "icon icon-card-fill" };
function Z2(n, c) {
  return s(), e("span", Q2);
}
const QG = /* @__PURE__ */ o(K2, [["render", Z2]]), j2 = {}, J2 = { class: "icon icon-card-regular" };
function X2(n, c) {
  return s(), e("span", J2);
}
const ZG = /* @__PURE__ */ o(j2, [["render", X2]]), Y2 = {}, n3 = { class: "icon icon-card-thin" };
function c3(n, c) {
  return s(), e("span", n3);
}
const jG = /* @__PURE__ */ o(Y2, [["render", c3]]), s3 = {}, e3 = { class: "icon icon-coin-1-fill" };
function o3(n, c) {
  return s(), e("span", e3);
}
const JG = /* @__PURE__ */ o(s3, [["render", o3]]), r3 = {}, _3 = { class: "icon icon-coin-1-regular" };
function t3(n, c) {
  return s(), e("span", _3);
}
const XG = /* @__PURE__ */ o(r3, [["render", t3]]), i3 = {}, a3 = { class: "icon icon-coin-1-thin" };
function d3(n, c) {
  return s(), e("span", a3);
}
const YG = /* @__PURE__ */ o(i3, [["render", d3]]), f3 = {}, l3 = { class: "icon icon-coin-2-fill" };
function u3(n, c) {
  return s(), e("span", l3);
}
const nW = /* @__PURE__ */ o(f3, [["render", u3]]), h3 = {}, $3 = { class: "icon icon-coin-2-regular" };
function p3(n, c) {
  return s(), e("span", $3);
}
const cW = /* @__PURE__ */ o(h3, [["render", p3]]), m3 = {}, g3 = { class: "icon icon-coin-2-thin" };
function x3(n, c) {
  return s(), e("span", g3);
}
const sW = /* @__PURE__ */ o(m3, [["render", x3]]), I3 = {}, R3 = { class: "icon icon-coin-3-fill" };
function T3(n, c) {
  return s(), e("span", R3);
}
const eW = /* @__PURE__ */ o(I3, [["render", T3]]), F3 = {}, b3 = { class: "icon icon-coin-3-regular" };
function C3(n, c) {
  return s(), e("span", b3);
}
const oW = /* @__PURE__ */ o(F3, [["render", C3]]), w3 = {}, y3 = { class: "icon icon-coin-3-thin" };
function v3(n, c) {
  return s(), e("span", y3);
}
const rW = /* @__PURE__ */ o(w3, [["render", v3]]), k3 = {}, S3 = { class: "icon icon-bill-fill" };
function D3(n, c) {
  return s(), e("span", S3);
}
const _W = /* @__PURE__ */ o(k3, [["render", D3]]), A3 = {}, M3 = { class: "icon icon-bill-regular" };
function P3(n, c) {
  return s(), e("span", M3);
}
const tW = /* @__PURE__ */ o(A3, [["render", P3]]), B3 = {}, L3 = { class: "icon icon-bill-thin" };
function U3(n, c) {
  return s(), e("span", L3);
}
const iW = /* @__PURE__ */ o(B3, [["render", U3]]), G3 = {}, W3 = { class: "icon icon-gift-fill" };
function V3(n, c) {
  return s(), e("span", W3);
}
const aW = /* @__PURE__ */ o(G3, [["render", V3]]), H3 = {}, E3 = { class: "icon icon-gift-regular" };
function z3(n, c) {
  return s(), e("span", E3);
}
const dW = /* @__PURE__ */ o(H3, [["render", z3]]), q3 = {}, N3 = { class: "icon icon-gift-thin" };
function O3(n, c) {
  return s(), e("span", N3);
}
const fW = /* @__PURE__ */ o(q3, [["render", O3]]), K3 = {}, Q3 = { class: "icon icon-bonus-regular" };
function Z3(n, c) {
  return s(), e("span", Q3);
}
const lW = /* @__PURE__ */ o(K3, [["render", Z3]]), j3 = {}, J3 = { class: "icon icon-bonus-thin" };
function X3(n, c) {
  return s(), e("span", J3);
}
const uW = /* @__PURE__ */ o(j3, [["render", X3]]), Y3 = {}, n5 = { class: "icon icon-bonus-fill" };
function c5(n, c) {
  return s(), e("span", n5);
}
const hW = /* @__PURE__ */ o(Y3, [["render", c5]]), s5 = {}, e5 = { class: "icon icon-promocode-fill" };
function o5(n, c) {
  return s(), e("span", e5);
}
const $W = /* @__PURE__ */ o(s5, [["render", o5]]), r5 = {}, _5 = { class: "icon icon-promocode-regular" };
function t5(n, c) {
  return s(), e("span", _5);
}
const pW = /* @__PURE__ */ o(r5, [["render", t5]]), i5 = {}, a5 = { class: "icon icon-promocode-thin" };
function d5(n, c) {
  return s(), e("span", a5);
}
const mW = /* @__PURE__ */ o(i5, [["render", d5]]), f5 = {}, l5 = { class: "icon icon-money-fill" };
function u5(n, c) {
  return s(), e("span", l5);
}
const gW = /* @__PURE__ */ o(f5, [["render", u5]]), h5 = {}, $5 = { class: "icon icon-money-regular" };
function p5(n, c) {
  return s(), e("span", $5);
}
const xW = /* @__PURE__ */ o(h5, [["render", p5]]), m5 = {}, g5 = { class: "icon icon-money-thin" };
function x5(n, c) {
  return s(), e("span", g5);
}
const IW = /* @__PURE__ */ o(m5, [["render", x5]]), I5 = {}, R5 = { class: "icon icon-balance-regular" };
function T5(n, c) {
  return s(), e("span", R5);
}
const RW = /* @__PURE__ */ o(I5, [["render", T5]]), F5 = {}, b5 = { class: "icon icon-balance-thin" };
function C5(n, c) {
  return s(), e("span", b5);
}
const TW = /* @__PURE__ */ o(F5, [["render", C5]]), w5 = {}, y5 = { class: "icon icon-box-regular" };
function v5(n, c) {
  return s(), e("span", y5);
}
const FW = /* @__PURE__ */ o(w5, [["render", v5]]), k5 = {}, S5 = { class: "icon icon-box-thin" };
function D5(n, c) {
  return s(), e("span", S5);
}
const bW = /* @__PURE__ */ o(k5, [["render", D5]]), A5 = {}, M5 = { class: "icon icon-box-fill" };
function P5(n, c) {
  return s(), e("span", M5);
}
const CW = /* @__PURE__ */ o(A5, [["render", P5]]), B5 = {}, L5 = { class: "icon icon-tag-regular" };
function U5(n, c) {
  return s(), e("span", L5);
}
const wW = /* @__PURE__ */ o(B5, [["render", U5]]), G5 = {}, W5 = { class: "icon icon-tag-thin" };
function V5(n, c) {
  return s(), e("span", W5);
}
const yW = /* @__PURE__ */ o(G5, [["render", V5]]), H5 = {}, E5 = { class: "icon icon-tag-fill" };
function z5(n, c) {
  return s(), e("span", E5);
}
const vW = /* @__PURE__ */ o(H5, [["render", z5]]), q5 = {}, N5 = { class: "icon icon-wallet-regular" };
function O5(n, c) {
  return s(), e("span", N5);
}
const kW = /* @__PURE__ */ o(q5, [["render", O5]]), K5 = {}, Q5 = { class: "icon icon-wallet-thin" };
function Z5(n, c) {
  return s(), e("span", Q5);
}
const SW = /* @__PURE__ */ o(K5, [["render", Z5]]), j5 = {}, J5 = { class: "icon icon-circle_help-fill" };
function X5(n, c) {
  return s(), e("span", J5);
}
const DW = /* @__PURE__ */ o(j5, [["render", X5]]), Y5 = {}, n7 = { class: "icon icon-circle_help-regular" };
function c7(n, c) {
  return s(), e("span", n7);
}
const AW = /* @__PURE__ */ o(Y5, [["render", c7]]), s7 = {}, e7 = { class: "icon icon-circle_help-thin" };
function o7(n, c) {
  return s(), e("span", e7);
}
const MW = /* @__PURE__ */ o(s7, [["render", o7]]), r7 = {}, _7 = { class: "icon icon-circle_add-fill" };
function t7(n, c) {
  return s(), e("span", _7);
}
const PW = /* @__PURE__ */ o(r7, [["render", t7]]), i7 = {}, a7 = { class: "icon icon-circle_add-regular" };
function d7(n, c) {
  return s(), e("span", a7);
}
const BW = /* @__PURE__ */ o(i7, [["render", d7]]), f7 = {}, l7 = { class: "icon icon-circle_add-thin" };
function u7(n, c) {
  return s(), e("span", l7);
}
const LW = /* @__PURE__ */ o(f7, [["render", u7]]), h7 = {}, $7 = { class: "icon icon-circle_close-fill" };
function p7(n, c) {
  return s(), e("span", $7);
}
const UW = /* @__PURE__ */ o(h7, [["render", p7]]), m7 = {}, g7 = { class: "icon icon-circle_close-regular" };
function x7(n, c) {
  return s(), e("span", g7);
}
const GW = /* @__PURE__ */ o(m7, [["render", x7]]), I7 = {}, R7 = { class: "icon icon-circle_close-thin" };
function T7(n, c) {
  return s(), e("span", R7);
}
const WW = /* @__PURE__ */ o(I7, [["render", T7]]), F7 = {}, b7 = { class: "icon icon-circle_info-fill" };
function C7(n, c) {
  return s(), e("span", b7);
}
const VW = /* @__PURE__ */ o(F7, [["render", C7]]), w7 = {}, y7 = { class: "icon icon-circle_info-regular" };
function v7(n, c) {
  return s(), e("span", y7);
}
const HW = /* @__PURE__ */ o(w7, [["render", v7]]), k7 = {}, S7 = { class: "icon icon-circle_info-thin" };
function D7(n, c) {
  return s(), e("span", S7);
}
const EW = /* @__PURE__ */ o(k7, [["render", D7]]), A7 = {}, M7 = { class: "icon icon-circle_remove-fill" };
function P7(n, c) {
  return s(), e("span", M7);
}
const zW = /* @__PURE__ */ o(A7, [["render", P7]]), B7 = {}, L7 = { class: "icon icon-circle_remove-regular" };
function U7(n, c) {
  return s(), e("span", L7);
}
const qW = /* @__PURE__ */ o(B7, [["render", U7]]), G7 = {}, W7 = { class: "icon icon-circle_remove-thin" };
function V7(n, c) {
  return s(), e("span", W7);
}
const NW = /* @__PURE__ */ o(G7, [["render", V7]]), H7 = {}, E7 = { class: "icon icon-circle_error-fill" };
function z7(n, c) {
  return s(), e("span", E7);
}
const OW = /* @__PURE__ */ o(H7, [["render", z7]]), q7 = {}, N7 = { class: "icon icon-circle_error-regular" };
function O7(n, c) {
  return s(), e("span", N7);
}
const KW = /* @__PURE__ */ o(q7, [["render", O7]]), K7 = {}, Q7 = { class: "icon icon-circle_error-thin" };
function Z7(n, c) {
  return s(), e("span", Q7);
}
const QW = /* @__PURE__ */ o(K7, [["render", Z7]]), j7 = {}, J7 = { class: "icon icon-circle_done-fill" };
function X7(n, c) {
  return s(), e("span", J7);
}
const ZW = /* @__PURE__ */ o(j7, [["render", X7]]), Y7 = {}, n4 = { class: "icon icon-circle_done-regular" };
function c4(n, c) {
  return s(), e("span", n4);
}
const jW = /* @__PURE__ */ o(Y7, [["render", c4]]), s4 = {}, e4 = { class: "icon icon-circle_done-thin" };
function o4(n, c) {
  return s(), e("span", e4);
}
const JW = /* @__PURE__ */ o(s4, [["render", o4]]), r4 = {}, _4 = { class: "icon icon-circle_support-regular" };
function t4(n, c) {
  return s(), e("span", _4);
}
const XW = /* @__PURE__ */ o(r4, [["render", t4]]), i4 = {}, a4 = { class: "icon icon-circle_support-thin" };
function d4(n, c) {
  return s(), e("span", a4);
}
const YW = /* @__PURE__ */ o(i4, [["render", d4]]), f4 = {}, l4 = { class: "icon icon-circle_block-regular" };
function u4(n, c) {
  return s(), e("span", l4);
}
const nV = /* @__PURE__ */ o(f4, [["render", u4]]), h4 = {}, $4 = { class: "icon icon-circle_block-thin" };
function p4(n, c) {
  return s(), e("span", $4);
}
const cV = /* @__PURE__ */ o(h4, [["render", p4]]), m4 = {}, g4 = { class: "icon icon-done-regular" };
function x4(n, c) {
  return s(), e("span", g4);
}
const sV = /* @__PURE__ */ o(m4, [["render", x4]]), I4 = {}, R4 = { class: "icon icon-done-thin" };
function T4(n, c) {
  return s(), e("span", R4);
}
const eV = /* @__PURE__ */ o(I4, [["render", T4]]), F4 = {}, b4 = { class: "icon icon-subtract-regular" };
function C4(n, c) {
  return s(), e("span", b4);
}
const oV = /* @__PURE__ */ o(F4, [["render", C4]]), w4 = {}, y4 = { class: "icon icon-subtract-thin" };
function v4(n, c) {
  return s(), e("span", y4);
}
const rV = /* @__PURE__ */ o(w4, [["render", v4]]), k4 = {}, S4 = { class: "icon icon-add-regular" };
function D4(n, c) {
  return s(), e("span", S4);
}
const _V = /* @__PURE__ */ o(k4, [["render", D4]]), A4 = {}, M4 = { class: "icon icon-add-thin" };
function P4(n, c) {
  return s(), e("span", M4);
}
const tV = /* @__PURE__ */ o(A4, [["render", P4]]), B4 = {}, L4 = { class: "icon icon-warning-fill" };
function U4(n, c) {
  return s(), e("span", L4);
}
const iV = /* @__PURE__ */ o(B4, [["render", U4]]), G4 = {}, W4 = { class: "icon icon-warning-regular" };
function V4(n, c) {
  return s(), e("span", W4);
}
const aV = /* @__PURE__ */ o(G4, [["render", V4]]), H4 = {}, E4 = { class: "icon icon-warning-thin" };
function z4(n, c) {
  return s(), e("span", E4);
}
const dV = /* @__PURE__ */ o(H4, [["render", z4]]), q4 = {}, N4 = { class: "icon icon-shield_done-fill" };
function O4(n, c) {
  return s(), e("span", N4);
}
const fV = /* @__PURE__ */ o(q4, [["render", O4]]), K4 = {}, Q4 = { class: "icon icon-edit-regular" };
function Z4(n, c) {
  return s(), e("span", Q4);
}
const lV = /* @__PURE__ */ o(K4, [["render", Z4]]), j4 = {}, J4 = { class: "icon icon-edit-thin" };
function X4(n, c) {
  return s(), e("span", J4);
}
const uV = /* @__PURE__ */ o(j4, [["render", X4]]), Y4 = {}, nF = { class: "icon icon-favorite-fill" };
function cF(n, c) {
  return s(), e("span", nF);
}
const hV = /* @__PURE__ */ o(Y4, [["render", cF]]), sF = {}, eF = { class: "icon icon-favorite-regular" };
function oF(n, c) {
  return s(), e("span", eF);
}
const $V = /* @__PURE__ */ o(sF, [["render", oF]]), rF = {}, _F = { class: "icon icon-favorite-thin" };
function tF(n, c) {
  return s(), e("span", _F);
}
const pV = /* @__PURE__ */ o(rF, [["render", tF]]), iF = {}, aF = { class: "icon icon-hide_2-regular" };
function dF(n, c) {
  return s(), e("span", aF);
}
const mV = /* @__PURE__ */ o(iF, [["render", dF]]), fF = {}, lF = { class: "icon icon-hide_2-thin" };
function uF(n, c) {
  return s(), e("span", lF);
}
const gV = /* @__PURE__ */ o(fF, [["render", uF]]), hF = {}, $F = { class: "icon icon-hide-fill" };
function pF(n, c) {
  return s(), e("span", $F);
}
const xV = /* @__PURE__ */ o(hF, [["render", pF]]), mF = {}, gF = { class: "icon icon-hide-regular" };
function xF(n, c) {
  return s(), e("span", gF);
}
const IV = /* @__PURE__ */ o(mF, [["render", xF]]), IF = {}, RF = { class: "icon icon-hide-thin" };
function TF(n, c) {
  return s(), e("span", RF);
}
const RV = /* @__PURE__ */ o(IF, [["render", TF]]), FF = {}, bF = { class: "icon icon-key-fill" };
function CF(n, c) {
  return s(), e("span", bF);
}
const TV = /* @__PURE__ */ o(FF, [["render", CF]]), wF = {}, yF = { class: "icon icon-key-regular" };
function vF(n, c) {
  return s(), e("span", yF);
}
const FV = /* @__PURE__ */ o(wF, [["render", vF]]), kF = {}, SF = { class: "icon icon-key-thin" };
function DF(n, c) {
  return s(), e("span", SF);
}
const bV = /* @__PURE__ */ o(kF, [["render", DF]]), AF = {}, MF = { class: "icon icon-link-regular" };
function PF(n, c) {
  return s(), e("span", MF);
}
const CV = /* @__PURE__ */ o(AF, [["render", PF]]), BF = {}, LF = { class: "icon icon-disconnect-regular" };
function UF(n, c) {
  return s(), e("span", LF);
}
const wV = /* @__PURE__ */ o(BF, [["render", UF]]), GF = {}, WF = { class: "icon icon-disconnect-thin" };
function VF(n, c) {
  return s(), e("span", WF);
}
const yV = /* @__PURE__ */ o(GF, [["render", VF]]), HF = {}, EF = { class: "icon icon-link-thin" };
function zF(n, c) {
  return s(), e("span", EF);
}
const vV = /* @__PURE__ */ o(HF, [["render", zF]]), qF = {}, NF = { class: "icon icon-lock-fill" };
function OF(n, c) {
  return s(), e("span", NF);
}
const kV = /* @__PURE__ */ o(qF, [["render", OF]]), KF = {}, QF = { class: "icon icon-lock-regular" };
function ZF(n, c) {
  return s(), e("span", QF);
}
const SV = /* @__PURE__ */ o(KF, [["render", ZF]]), jF = {}, JF = { class: "icon icon-lock-thin" };
function XF(n, c) {
  return s(), e("span", JF);
}
const DV = /* @__PURE__ */ o(jF, [["render", XF]]), YF = {}, n6 = { class: "icon icon-moon-fill" };
function c6(n, c) {
  return s(), e("span", n6);
}
const AV = /* @__PURE__ */ o(YF, [["render", c6]]), s6 = {}, e6 = { class: "icon icon-moon-regular" };
function o6(n, c) {
  return s(), e("span", e6);
}
const MV = /* @__PURE__ */ o(s6, [["render", o6]]), r6 = {}, _6 = { class: "icon icon-moon-thin" };
function t6(n, c) {
  return s(), e("span", _6);
}
const PV = /* @__PURE__ */ o(r6, [["render", t6]]), i6 = {}, a6 = { class: "icon icon-network-regular" };
function d6(n, c) {
  return s(), e("span", a6);
}
const BV = /* @__PURE__ */ o(i6, [["render", d6]]), f6 = {}, l6 = { class: "icon icon-network-thin" };
function u6(n, c) {
  return s(), e("span", l6);
}
const LV = /* @__PURE__ */ o(f6, [["render", u6]]), h6 = {}, $6 = { class: "icon icon-search-regular" };
function p6(n, c) {
  return s(), e("span", $6);
}
const UV = /* @__PURE__ */ o(h6, [["render", p6]]), m6 = {}, g6 = { class: "icon icon-search-thin" };
function x6(n, c) {
  return s(), e("span", g6);
}
const GV = /* @__PURE__ */ o(m6, [["render", x6]]), I6 = {}, R6 = { class: "icon icon-share_alt-fill" };
function T6(n, c) {
  return s(), e("span", R6);
}
const WV = /* @__PURE__ */ o(I6, [["render", T6]]), F6 = {}, b6 = { class: "icon icon-share_alt-regular" };
function C6(n, c) {
  return s(), e("span", b6);
}
const VV = /* @__PURE__ */ o(F6, [["render", C6]]), w6 = {}, y6 = { class: "icon icon-share_alt-thin" };
function v6(n, c) {
  return s(), e("span", y6);
}
const HV = /* @__PURE__ */ o(w6, [["render", v6]]), k6 = {}, S6 = { class: "icon icon-share-regular" };
function D6(n, c) {
  return s(), e("span", S6);
}
const EV = /* @__PURE__ */ o(k6, [["render", D6]]), A6 = {}, M6 = { class: "icon icon-share-thin" };
function P6(n, c) {
  return s(), e("span", M6);
}
const zV = /* @__PURE__ */ o(A6, [["render", P6]]), B6 = {}, L6 = { class: "icon icon-show-fill" };
function U6(n, c) {
  return s(), e("span", L6);
}
const qV = /* @__PURE__ */ o(B6, [["render", U6]]), G6 = {}, W6 = { class: "icon icon-show-regular" };
function V6(n, c) {
  return s(), e("span", W6);
}
const NV = /* @__PURE__ */ o(G6, [["render", V6]]), H6 = {}, E6 = { class: "icon icon-show-thin" };
function z6(n, c) {
  return s(), e("span", E6);
}
const OV = /* @__PURE__ */ o(H6, [["render", z6]]), q6 = {}, N6 = { class: "icon icon-signal-regular" };
function O6(n, c) {
  return s(), e("span", N6);
}
const KV = /* @__PURE__ */ o(q6, [["render", O6]]), K6 = {}, Q6 = { class: "icon icon-signal-thin" };
function Z6(n, c) {
  return s(), e("span", Q6);
}
const QV = /* @__PURE__ */ o(K6, [["render", Z6]]), j6 = {}, J6 = { class: "icon icon-star_0-regular" };
function X6(n, c) {
  return s(), e("span", J6);
}
const ZV = /* @__PURE__ */ o(j6, [["render", X6]]), Y6 = {}, n8 = { class: "icon icon-star_0-thin" };
function c8(n, c) {
  return s(), e("span", n8);
}
const jV = /* @__PURE__ */ o(Y6, [["render", c8]]), s8 = {}, e8 = { class: "icon icon-star_25-regular" };
function o8(n, c) {
  return s(), e("span", e8);
}
const JV = /* @__PURE__ */ o(s8, [["render", o8]]), r8 = {}, _8 = { class: "icon icon-star_25-thin" };
function t8(n, c) {
  return s(), e("span", _8);
}
const XV = /* @__PURE__ */ o(r8, [["render", t8]]), i8 = {}, a8 = { class: "icon icon-star_50-regular" };
function d8(n, c) {
  return s(), e("span", a8);
}
const YV = /* @__PURE__ */ o(i8, [["render", d8]]), f8 = {}, l8 = { class: "icon icon-star_50-thin" };
function u8(n, c) {
  return s(), e("span", l8);
}
const nH = /* @__PURE__ */ o(f8, [["render", u8]]), h8 = {}, $8 = { class: "icon icon-star_75-regular" };
function p8(n, c) {
  return s(), e("span", $8);
}
const cH = /* @__PURE__ */ o(h8, [["render", p8]]), m8 = {}, g8 = { class: "icon icon-star_75-thin" };
function x8(n, c) {
  return s(), e("span", g8);
}
const sH = /* @__PURE__ */ o(m8, [["render", x8]]), I8 = {}, R8 = { class: "icon icon-star_100-regular" };
function T8(n, c) {
  return s(), e("span", R8);
}
const eH = /* @__PURE__ */ o(I8, [["render", T8]]), F8 = {}, b8 = { class: "icon icon-sun-fill" };
function C8(n, c) {
  return s(), e("span", b8);
}
const oH = /* @__PURE__ */ o(F8, [["render", C8]]), w8 = {}, y8 = { class: "icon icon-sun-regular" };
function v8(n, c) {
  return s(), e("span", y8);
}
const rH = /* @__PURE__ */ o(w8, [["render", v8]]), k8 = {}, S8 = { class: "icon icon-sun-thin" };
function D8(n, c) {
  return s(), e("span", S8);
}
const _H = /* @__PURE__ */ o(k8, [["render", D8]]), A8 = {}, M8 = { class: "icon icon-unlock-fill" };
function P8(n, c) {
  return s(), e("span", M8);
}
const tH = /* @__PURE__ */ o(A8, [["render", P8]]), B8 = {}, L8 = { class: "icon icon-unlock-regular" };
function U8(n, c) {
  return s(), e("span", L8);
}
const iH = /* @__PURE__ */ o(B8, [["render", U8]]), G8 = {}, W8 = { class: "icon icon-unlock-thin" };
function V8(n, c) {
  return s(), e("span", W8);
}
const aH = /* @__PURE__ */ o(G8, [["render", V8]]), H8 = {}, E8 = { class: "icon icon-circle_pause-fill" };
function z8(n, c) {
  return s(), e("span", E8);
}
const dH = /* @__PURE__ */ o(H8, [["render", z8]]), q8 = {}, N8 = { class: "icon icon-circle_pause-regular" };
function O8(n, c) {
  return s(), e("span", N8);
}
const fH = /* @__PURE__ */ o(q8, [["render", O8]]), K8 = {}, Q8 = { class: "icon icon-circle_pause-thin" };
function Z8(n, c) {
  return s(), e("span", Q8);
}
const lH = /* @__PURE__ */ o(K8, [["render", Z8]]), j8 = {}, J8 = { class: "icon icon-circle_play-fill" };
function X8(n, c) {
  return s(), e("span", J8);
}
const uH = /* @__PURE__ */ o(j8, [["render", X8]]), Y8 = {}, n9 = { class: "icon icon-circle_play-regular" };
function c9(n, c) {
  return s(), e("span", n9);
}
const hH = /* @__PURE__ */ o(Y8, [["render", c9]]), s9 = {}, e9 = { class: "icon icon-circle_play-thin" };
function o9(n, c) {
  return s(), e("span", e9);
}
const $H = /* @__PURE__ */ o(s9, [["render", o9]]), r9 = {}, _9 = { class: "icon icon-desktop-regular" };
function t9(n, c) {
  return s(), e("span", _9);
}
const pH = /* @__PURE__ */ o(r9, [["render", t9]]), i9 = {}, a9 = { class: "icon icon-desktop-thin" };
function d9(n, c) {
  return s(), e("span", a9);
}
const mH = /* @__PURE__ */ o(i9, [["render", d9]]), f9 = {}, l9 = { class: "icon icon-image-fill" };
function u9(n, c) {
  return s(), e("span", l9);
}
const gH = /* @__PURE__ */ o(f9, [["render", u9]]), h9 = {}, $9 = { class: "icon icon-image-regular" };
function p9(n, c) {
  return s(), e("span", $9);
}
const xH = /* @__PURE__ */ o(h9, [["render", p9]]), m9 = {}, g9 = { class: "icon icon-image-thin" };
function x9(n, c) {
  return s(), e("span", g9);
}
const IH = /* @__PURE__ */ o(m9, [["render", x9]]), I9 = {}, R9 = { class: "icon icon-laptop-regular" };
function T9(n, c) {
  return s(), e("span", R9);
}
const RH = /* @__PURE__ */ o(I9, [["render", T9]]), F9 = {}, b9 = { class: "icon icon-laptop-thin" };
function C9(n, c) {
  return s(), e("span", b9);
}
const TH = /* @__PURE__ */ o(F9, [["render", C9]]), w9 = {}, y9 = { class: "icon icon-pause-regular" };
function v9(n, c) {
  return s(), e("span", y9);
}
const FH = /* @__PURE__ */ o(w9, [["render", v9]]), k9 = {}, S9 = { class: "icon icon-pause-thin" };
function D9(n, c) {
  return s(), e("span", S9);
}
const bH = /* @__PURE__ */ o(k9, [["render", D9]]), A9 = {}, M9 = { class: "icon icon-mobile-regular" };
function P9(n, c) {
  return s(), e("span", M9);
}
const CH = /* @__PURE__ */ o(A9, [["render", P9]]), B9 = {}, L9 = { class: "icon icon-mobile-thin" };
function U9(n, c) {
  return s(), e("span", L9);
}
const wH = /* @__PURE__ */ o(B9, [["render", U9]]), G9 = {}, W9 = { class: "icon icon-play-fill" };
function V9(n, c) {
  return s(), e("span", W9);
}
const yH = /* @__PURE__ */ o(G9, [["render", V9]]), H9 = {}, E9 = { class: "icon icon-play-regular" };
function z9(n, c) {
  return s(), e("span", E9);
}
const vH = /* @__PURE__ */ o(H9, [["render", z9]]), q9 = {}, N9 = { class: "icon icon-play-thin" };
function O9(n, c) {
  return s(), e("span", N9);
}
const kH = /* @__PURE__ */ o(q9, [["render", O9]]), K9 = {}, Q9 = { class: "icon icon-tablet-regular" };
function Z9(n, c) {
  return s(), e("span", Q9);
}
const SH = /* @__PURE__ */ o(K9, [["render", Z9]]), j9 = {}, J9 = { class: "icon icon-tablet-thin" };
function X9(n, c) {
  return s(), e("span", J9);
}
const DH = /* @__PURE__ */ o(j9, [["render", X9]]), Y9 = {}, nb = { class: "icon icon-camera-fill" };
function cb(n, c) {
  return s(), e("span", nb);
}
const AH = /* @__PURE__ */ o(Y9, [["render", cb]]), sb = {}, eb = { class: "icon icon-camera-regular" };
function ob(n, c) {
  return s(), e("span", eb);
}
const MH = /* @__PURE__ */ o(sb, [["render", ob]]), rb = {}, _b = { class: "icon icon-camera-thin" };
function tb(n, c) {
  return s(), e("span", _b);
}
const PH = /* @__PURE__ */ o(rb, [["render", tb]]), ib = {}, ab = { class: "icon icon-bolt-fill" };
function db(n, c) {
  return s(), e("span", ab);
}
const BH = /* @__PURE__ */ o(ib, [["render", db]]), fb = {}, lb = { class: "icon icon-bolt-regular" };
function ub(n, c) {
  return s(), e("span", lb);
}
const LH = /* @__PURE__ */ o(fb, [["render", ub]]), hb = {}, $b = { class: "icon icon-bolt-thin" };
function pb(n, c) {
  return s(), e("span", $b);
}
const UH = /* @__PURE__ */ o(hb, [["render", pb]]), mb = {}, gb = { class: "icon icon-bolt_off-fill" };
function xb(n, c) {
  return s(), e("span", gb);
}
const GH = /* @__PURE__ */ o(mb, [["render", xb]]), Ib = {}, Rb = { class: "icon icon-bolt_off-regular" };
function Tb(n, c) {
  return s(), e("span", Rb);
}
const WH = /* @__PURE__ */ o(Ib, [["render", Tb]]), Fb = {}, bb = { class: "icon icon-bolt_off-thin" };
function Cb(n, c) {
  return s(), e("span", bb);
}
const VH = /* @__PURE__ */ o(Fb, [["render", Cb]]), wb = {}, yb = { class: "icon icon-video-fill" };
function vb(n, c) {
  return s(), e("span", yb);
}
const HH = /* @__PURE__ */ o(wb, [["render", vb]]), kb = {}, Sb = { class: "icon icon-video-regular" };
function Db(n, c) {
  return s(), e("span", Sb);
}
const EH = /* @__PURE__ */ o(kb, [["render", Db]]), Ab = {}, Mb = { class: "icon icon-video-thin" };
function Pb(n, c) {
  return s(), e("span", Mb);
}
const zH = /* @__PURE__ */ o(Ab, [["render", Pb]]), Bb = {}, Lb = { class: "icon icon-volume_full-fill" };
function Ub(n, c) {
  return s(), e("span", Lb);
}
const qH = /* @__PURE__ */ o(Bb, [["render", Ub]]), Gb = {}, Wb = { class: "icon icon-volume_full-regular" };
function Vb(n, c) {
  return s(), e("span", Wb);
}
const NH = /* @__PURE__ */ o(Gb, [["render", Vb]]), Hb = {}, Eb = { class: "icon icon-volume_full-thin" };
function zb(n, c) {
  return s(), e("span", Eb);
}
const OH = /* @__PURE__ */ o(Hb, [["render", zb]]), qb = {}, Nb = { class: "icon icon-volume_half-fill" };
function Ob(n, c) {
  return s(), e("span", Nb);
}
const KH = /* @__PURE__ */ o(qb, [["render", Ob]]), Kb = {}, Qb = { class: "icon icon-volume_half-regular" };
function Zb(n, c) {
  return s(), e("span", Qb);
}
const QH = /* @__PURE__ */ o(Kb, [["render", Zb]]), jb = {}, Jb = { class: "icon icon-volume_half-thin" };
function Xb(n, c) {
  return s(), e("span", Jb);
}
const ZH = /* @__PURE__ */ o(jb, [["render", Xb]]), Yb = {}, nC = { class: "icon icon-volume_zero-fill" };
function cC(n, c) {
  return s(), e("span", nC);
}
const jH = /* @__PURE__ */ o(Yb, [["render", cC]]), sC = {}, eC = { class: "icon icon-volume_zero-regular" };
function oC(n, c) {
  return s(), e("span", eC);
}
const JH = /* @__PURE__ */ o(sC, [["render", oC]]), rC = {}, _C = { class: "icon icon-volume_zero-thin" };
function tC(n, c) {
  return s(), e("span", _C);
}
const XH = /* @__PURE__ */ o(rC, [["render", tC]]), iC = {}, aC = { class: "icon icon-water-fill" };
function dC(n, c) {
  return s(), e("span", aC);
}
const YH = /* @__PURE__ */ o(iC, [["render", dC]]), fC = {}, lC = { class: "icon icon-water-regular" };
function uC(n, c) {
  return s(), e("span", lC);
}
const nE = /* @__PURE__ */ o(fC, [["render", uC]]), hC = {}, $C = { class: "icon icon-water-thin" };
function pC(n, c) {
  return s(), e("span", $C);
}
const cE = /* @__PURE__ */ o(hC, [["render", pC]]), mC = {}, gC = { class: "icon icon-cashback-history-regular" };
function xC(n, c) {
  return s(), e("span", gC);
}
const sE = /* @__PURE__ */ o(mC, [["render", xC]]), IC = {}, RC = { class: "icon icon-cashback-history-thin" };
function TC(n, c) {
  return s(), e("span", RC);
}
const eE = /* @__PURE__ */ o(IC, [["render", TC]]), FC = {}, bC = { class: "type-file-icon icon-image-jpg-regular" };
function CC(n, c) {
  return s(), e("span", bC);
}
const oE = /* @__PURE__ */ o(FC, [["render", CC]]), wC = {}, yC = { class: "type-file-icon icon-image-jpg-thin" };
function vC(n, c) {
  return s(), e("span", yC);
}
const rE = /* @__PURE__ */ o(wC, [["render", vC]]), kC = {}, SC = { class: "type-file-icon icon-archive-zip-regular" };
function DC(n, c) {
  return s(), e("span", SC);
}
const _E = /* @__PURE__ */ o(kC, [["render", DC]]), AC = {}, MC = { class: "type-file-icon icon-archive-zip-thin" };
function PC(n, c) {
  return s(), e("span", MC);
}
const tE = /* @__PURE__ */ o(AC, [["render", PC]]), BC = {}, LC = { class: "type-file-icon icon-archive-rar-regular" };
function UC(n, c) {
  return s(), e("span", LC);
}
const iE = /* @__PURE__ */ o(BC, [["render", UC]]), GC = {}, WC = { class: "type-file-icon icon-archive-rar-thin" };
function VC(n, c) {
  return s(), e("span", WC);
}
const aE = /* @__PURE__ */ o(GC, [["render", VC]]), HC = {}, EC = { class: "type-file-icon icon-image-png-regular" };
function zC(n, c) {
  return s(), e("span", EC);
}
const dE = /* @__PURE__ */ o(HC, [["render", zC]]), qC = {}, NC = { class: "type-file-icon icon-image-png-thin" };
function OC(n, c) {
  return s(), e("span", NC);
}
const fE = /* @__PURE__ */ o(qC, [["render", OC]]), KC = {}, QC = { class: "type-file-icon icon-image-gif-regular" };
function ZC(n, c) {
  return s(), e("span", QC);
}
const lE = /* @__PURE__ */ o(KC, [["render", ZC]]), jC = {}, JC = { class: "type-file-icon icon-image-gif-thin" };
function XC(n, c) {
  return s(), e("span", JC);
}
const uE = /* @__PURE__ */ o(jC, [["render", XC]]), YC = {}, nw = { class: "type-file-icon icon-image-svg-regular" };
function cw(n, c) {
  return s(), e("span", nw);
}
const hE = /* @__PURE__ */ o(YC, [["render", cw]]), sw = {}, ew = { class: "type-file-icon icon-image-svg-thin" };
function ow(n, c) {
  return s(), e("span", ew);
}
const $E = /* @__PURE__ */ o(sw, [["render", ow]]), rw = {}, _w = { class: "type-file-icon icon-image-img-regular" };
function tw(n, c) {
  return s(), e("span", _w);
}
const pE = /* @__PURE__ */ o(rw, [["render", tw]]), iw = {}, aw = { class: "type-file-icon icon-image-img-thin" };
function dw(n, c) {
  return s(), e("span", aw);
}
const mE = /* @__PURE__ */ o(iw, [["render", dw]]), fw = {}, lw = { class: "type-file-icon icon-media-avi-regular" };
function uw(n, c) {
  return s(), e("span", lw);
}
const gE = /* @__PURE__ */ o(fw, [["render", uw]]), hw = {}, $w = { class: "type-file-icon icon-media-wav-thin" };
function pw(n, c) {
  return s(), e("span", $w);
}
const xE = /* @__PURE__ */ o(hw, [["render", pw]]), mw = {}, gw = { class: "type-file-icon icon-media-wav-regular" };
function xw(n, c) {
  return s(), e("span", gw);
}
const IE = /* @__PURE__ */ o(mw, [["render", xw]]), Iw = {}, Rw = { class: "type-file-icon icon-media-wav-thin" };
function Tw(n, c) {
  return s(), e("span", Rw);
}
const RE = /* @__PURE__ */ o(Iw, [["render", Tw]]), Fw = {}, bw = { class: "type-file-icon icon-media-mp4-regular" };
function Cw(n, c) {
  return s(), e("span", bw);
}
const TE = /* @__PURE__ */ o(Fw, [["render", Cw]]), ww = {}, yw = { class: "type-file-icon icon-media-wav-thin" };
function vw(n, c) {
  return s(), e("span", yw);
}
const FE = /* @__PURE__ */ o(ww, [["render", vw]]), kw = {}, Sw = { class: "type-file-icon icon-media-mp3-regular" };
function Dw(n, c) {
  return s(), e("span", Sw);
}
const bE = /* @__PURE__ */ o(kw, [["render", Dw]]), Aw = {}, Mw = { class: "type-file-icon icon-media-wav-thin" };
function Pw(n, c) {
  return s(), e("span", Mw);
}
const CE = /* @__PURE__ */ o(Aw, [["render", Pw]]), Bw = {}, Lw = { class: "type-file-icon icon-document-pptx-regular" };
function Uw(n, c) {
  return s(), e("span", Lw);
}
const wE = /* @__PURE__ */ o(Bw, [["render", Uw]]), Gw = {}, Ww = { class: "type-file-icon icon-document-pptx-thin" };
function Vw(n, c) {
  return s(), e("span", Ww);
}
const yE = /* @__PURE__ */ o(Gw, [["render", Vw]]), Hw = {}, Ew = { class: "type-file-icon icon-document-ppt-regular" };
function zw(n, c) {
  return s(), e("span", Ew);
}
const vE = /* @__PURE__ */ o(Hw, [["render", zw]]), qw = {}, Nw = { class: "type-file-icon icon-document-ppt-thin" };
function Ow(n, c) {
  return s(), e("span", Nw);
}
const kE = /* @__PURE__ */ o(qw, [["render", Ow]]), Kw = {}, Qw = { class: "type-file-icon icon-document-xlsx-regular" };
function Zw(n, c) {
  return s(), e("span", Qw);
}
const SE = /* @__PURE__ */ o(Kw, [["render", Zw]]), jw = {}, Jw = { class: "type-file-icon icon-document-xlsx-thin" };
function Xw(n, c) {
  return s(), e("span", Jw);
}
const DE = /* @__PURE__ */ o(jw, [["render", Xw]]), Yw = {}, ny = { class: "type-file-icon icon-document-xls-regular" };
function cy(n, c) {
  return s(), e("span", ny);
}
const AE = /* @__PURE__ */ o(Yw, [["render", cy]]), sy = {}, ey = { class: "type-file-icon icon-document-xls-thin" };
function oy(n, c) {
  return s(), e("span", ey);
}
const ME = /* @__PURE__ */ o(sy, [["render", oy]]), ry = {}, _y = { class: "type-file-icon icon-document-csv-regular" };
function ty(n, c) {
  return s(), e("span", _y);
}
const PE = /* @__PURE__ */ o(ry, [["render", ty]]), iy = {}, ay = { class: "type-file-icon icon-document-csv-thin" };
function dy(n, c) {
  return s(), e("span", ay);
}
const BE = /* @__PURE__ */ o(iy, [["render", dy]]), fy = {}, ly = { class: "type-file-icon icon-document-txt-regular" };
function uy(n, c) {
  return s(), e("span", ly);
}
const LE = /* @__PURE__ */ o(fy, [["render", uy]]), hy = {}, $y = { class: "type-file-icon icon-document-txt-thin" };
function py(n, c) {
  return s(), e("span", $y);
}
const UE = /* @__PURE__ */ o(hy, [["render", py]]), my = {}, gy = { class: "type-file-icon icon-document-docx-regular" };
function xy(n, c) {
  return s(), e("span", gy);
}
const GE = /* @__PURE__ */ o(my, [["render", xy]]), Iy = {}, Ry = { class: "type-file-icon icon-document-docx-thin" };
function Ty(n, c) {
  return s(), e("span", Ry);
}
const WE = /* @__PURE__ */ o(Iy, [["render", Ty]]), Fy = {}, by = { class: "type-file-icon icon-document-doc-regular" };
function Cy(n, c) {
  return s(), e("span", by);
}
const VE = /* @__PURE__ */ o(Fy, [["render", Cy]]), wy = {}, yy = { class: "type-file-icon icon-document-doc-thin" };
function vy(n, c) {
  return s(), e("span", yy);
}
const HE = /* @__PURE__ */ o(wy, [["render", vy]]), ky = {}, Sy = { class: "type-file-icon icon-document-pdf-regular" };
function Dy(n, c) {
  return s(), e("span", Sy);
}
const EE = /* @__PURE__ */ o(ky, [["render", Dy]]), Ay = {}, My = { class: "type-file-icon icon-document-pdf-thin" };
function Py(n, c) {
  return s(), e("span", My);
}
const zE = /* @__PURE__ */ o(Ay, [["render", Py]]), By = {}, Ly = { class: "icon icon-tariff_business-fill" };
function Uy(n, c) {
  return s(), e("span", Ly);
}
const qE = /* @__PURE__ */ o(By, [["render", Uy]]), Gy = {}, Wy = { class: "icon icon-tariff_franchise-fill" };
function Vy(n, c) {
  return s(), e("span", Wy);
}
const NE = /* @__PURE__ */ o(Gy, [["render", Vy]]), Hy = {}, Ey = { class: "icon icon-tariff_free-fill" };
function zy(n, c) {
  return s(), e("span", Ey);
}
const OE = /* @__PURE__ */ o(Hy, [["render", zy]]), qy = {}, Ny = { class: "icon icon-tariff_gold-fill" };
function Oy(n, c) {
  return s(), e("span", Ny);
}
const KE = /* @__PURE__ */ o(qy, [["render", Oy]]), Ky = {}, Qy = { class: "icon icon-tariff_premium-fill" };
function Zy(n, c) {
  return s(), e("span", Qy);
}
const QE = /* @__PURE__ */ o(Ky, [["render", Zy]]), jy = {}, Jy = { class: "icon icon-tariff_smart-fill" };
function Xy(n, c) {
  return s(), e("span", Jy);
}
const ZE = /* @__PURE__ */ o(jy, [["render", Xy]]), Yy = {}, nv = { class: "icon icon-tariff_standart-fill" };
function cv(n, c) {
  return s(), e("span", nv);
}
const jE = /* @__PURE__ */ o(Yy, [["render", cv]]), sv = {}, ev = { class: "icon icon-diamond-regular" };
function ov(n, c) {
  return s(), e("span", ev);
}
const JE = /* @__PURE__ */ o(sv, [["render", ov]]), rv = {}, _v = { class: "icon icon-diamond-thin" };
function tv(n, c) {
  return s(), e("span", _v);
}
const XE = /* @__PURE__ */ o(rv, [["render", tv]]), iv = {}, av = { class: "icon icon-queen-fill" };
function dv(n, c) {
  return s(), e("span", av);
}
const YE = /* @__PURE__ */ o(iv, [["render", dv]]), fv = {}, lv = { class: "icon icon-queen-regular" };
function uv(n, c) {
  return s(), e("span", lv);
}
const nz = /* @__PURE__ */ o(fv, [["render", uv]]), hv = {}, $v = { class: "icon icon-queen-thin" };
function pv(n, c) {
  return s(), e("span", $v);
}
const cz = /* @__PURE__ */ o(hv, [["render", pv]]), mv = {}, gv = { class: "icon icon-king-fill" };
function xv(n, c) {
  return s(), e("span", gv);
}
const sz = /* @__PURE__ */ o(mv, [["render", xv]]), Iv = {}, Rv = { class: "icon icon-king-regular" };
function Tv(n, c) {
  return s(), e("span", Rv);
}
const ez = /* @__PURE__ */ o(Iv, [["render", Tv]]), Fv = {}, bv = { class: "icon icon-king-thin" };
function Cv(n, c) {
  return s(), e("span", bv);
}
const oz = /* @__PURE__ */ o(Fv, [["render", Cv]]), wv = {}, yv = { class: "icon icon-double_star-fill" };
function vv(n, c) {
  return s(), e("span", yv);
}
const rz = /* @__PURE__ */ o(wv, [["render", vv]]), kv = {}, Sv = { class: "icon icon-double_star-regular" };
function Dv(n, c) {
  return s(), e("span", Sv);
}
const _z = /* @__PURE__ */ o(kv, [["render", Dv]]), Av = {}, Mv = { class: "icon icon-double_star-thin" };
function Pv(n, c) {
  return s(), e("span", Mv);
}
const tz = /* @__PURE__ */ o(Av, [["render", Pv]]), Bv = {}, Lv = { class: "icon icon-crop-fill" };
function Uv(n, c) {
  return s(), e("span", Lv);
}
const iz = /* @__PURE__ */ o(Bv, [["render", Uv]]), Gv = {}, Wv = { class: "icon icon-crop-regular" };
function Vv(n, c) {
  return s(), e("span", Wv);
}
const az = /* @__PURE__ */ o(Gv, [["render", Vv]]), Hv = {}, Ev = { class: "icon icon-crop-thin" };
function zv(n, c) {
  return s(), e("span", Ev);
}
const dz = /* @__PURE__ */ o(Hv, [["render", zv]]), qv = {}, Nv = { class: "icon icon-search_categories-thin" };
function Ov(n, c) {
  return s(), e("span", Nv);
}
const fz = /* @__PURE__ */ o(qv, [["render", Ov]]), Kv = {}, Qv = { class: "icon icon-search_categories-regular" };
function Zv(n, c) {
  return s(), e("span", Qv);
}
const lz = /* @__PURE__ */ o(Kv, [["render", Zv]]), jv = {}, Jv = { class: "icon icon-languages_eng-regular" };
function Xv(n, c) {
  return s(), e("span", Jv);
}
const uz = /* @__PURE__ */ o(jv, [["render", Xv]]), Yv = {}, nk = { class: "icon icon-languages_eng-fill" };
function ck(n, c) {
  return s(), e("span", nk);
}
const hz = /* @__PURE__ */ o(Yv, [["render", ck]]), sk = {}, ek = { class: "icon icon-languages_ro-regular" };
function ok(n, c) {
  return s(), e("span", ek);
}
const $z = /* @__PURE__ */ o(sk, [["render", ok]]), rk = {}, _k = { class: "icon icon-languages_ro-fill" };
function tk(n, c) {
  return s(), e("span", _k);
}
const pz = /* @__PURE__ */ o(rk, [["render", tk]]), ik = {}, ak = { class: "icon icon-languages_ru-regular" };
function dk(n, c) {
  return s(), e("span", ak);
}
const mz = /* @__PURE__ */ o(ik, [["render", dk]]), fk = {}, lk = { class: "icon icon-languages_ru-fill" };
function uk(n, c) {
  return s(), e("span", lk);
}
const gz = /* @__PURE__ */ o(fk, [["render", uk]]), hk = {}, $k = { class: "icon icon-languages_ka-regular" };
function pk(n, c) {
  return s(), e("span", $k);
}
const xz = /* @__PURE__ */ o(hk, [["render", pk]]), mk = {}, gk = { class: "icon icon-languages_ka-fill" };
function xk(n, c) {
  return s(), e("span", gk);
}
const Iz = /* @__PURE__ */ o(mk, [["render", xk]]), Ik = {}, Rk = { class: "color-icon icon-sbp" };
function Tk(n, c) {
  return s(), e("span", Rk);
}
const Rz = /* @__PURE__ */ o(Ik, [["render", Tk]]), Fk = {}, bk = { class: "icon icon-sbp-dark" };
function Ck(n, c) {
  return s(), e("span", bk);
}
const Tz = /* @__PURE__ */ o(Fk, [["render", Ck]]), wk = {}, yk = { class: "icon icon-android-fill" };
function vk(n, c) {
  return s(), e("span", yk);
}
const Fz = /* @__PURE__ */ o(wk, [["render", vk]]), kk = {}, Sk = { class: "icon icon-iOS-fill" };
function Dk(n, c) {
  return s(), e("span", Sk);
}
const bz = /* @__PURE__ */ o(kk, [["render", Dk]]), Ak = {}, Mk = { class: "icon icon-face_id-fill" };
function Pk(n, c) {
  return s(), e("span", Mk);
}
const Cz = /* @__PURE__ */ o(Ak, [["render", Pk]]), Bk = {}, Lk = { class: "icon icon-face_id-regular" };
function Uk(n, c) {
  return s(), e("span", Lk);
}
const wz = /* @__PURE__ */ o(Bk, [["render", Uk]]), Gk = {}, Wk = { class: "icon icon-face_id-thin" };
function Vk(n, c) {
  return s(), e("span", Wk);
}
const yz = /* @__PURE__ */ o(Gk, [["render", Vk]]), Hk = {}, Ek = { class: "icon icon-touch_id-regular" };
function zk(n, c) {
  return s(), e("span", Ek);
}
const vz = /* @__PURE__ */ o(Hk, [["render", zk]]), qk = {}, Nk = { class: "icon icon-touch_id-thin" };
function Ok(n, c) {
  return s(), e("span", Nk);
}
const kz = /* @__PURE__ */ o(qk, [["render", Ok]]), Kk = {}, Qk = { class: "icon icon-columns_2-regular" };
function Zk(n, c) {
  return s(), e("span", Qk);
}
const Sz = /* @__PURE__ */ o(Kk, [["render", Zk]]), jk = {}, Jk = { class: "icon icon-columns_2-thin" };
function Xk(n, c) {
  return s(), e("span", Jk);
}
const Dz = /* @__PURE__ */ o(jk, [["render", Xk]]), Yk = {}, nS = { class: "icon icon-columns_3-regular" };
function cS(n, c) {
  return s(), e("span", nS);
}
const Az = /* @__PURE__ */ o(Yk, [["render", cS]]), sS = {}, eS = { class: "icon icon-columns_3-regular" };
function oS(n, c) {
  return s(), e("span", eS);
}
const Mz = /* @__PURE__ */ o(sS, [["render", oS]]), rS = {}, _S = { class: "icon icon-circle_reply-fill" };
function tS(n, c) {
  return s(), e("span", _S);
}
const Pz = /* @__PURE__ */ o(rS, [["render", tS]]), iS = {}, aS = { class: "icon icon-circle_reply-thin" };
function dS(n, c) {
  return s(), e("span", aS);
}
const Bz = /* @__PURE__ */ o(iS, [["render", dS]]), fS = {}, lS = { class: "icon icon-circle_reply-regular" };
function uS(n, c) {
  return s(), e("span", lS);
}
const Lz = /* @__PURE__ */ o(fS, [["render", uS]]), hS = {}, $S = { class: "icon icon-check-indicator-regular" };
function pS(n, c) {
  return s(), e("span", $S);
}
const Uz = /* @__PURE__ */ o(hS, [["render", pS]]);
export {
  KM as IconAccountFill,
  QM as IconAccountRegular,
  ZM as IconAccountThin,
  FM as IconAccountTransitionRegular,
  bM as IconAccountTransitionThin,
  _V as IconAddRegular,
  tV as IconAddThin,
  DM as IconAgeFill,
  AM as IconAgeRegular,
  MM as IconAgeThin,
  HD as IconAlarmFill,
  ED as IconAlarmRegular,
  zD as IconAlarmThin,
  Fz as IconAndroidFill,
  gS as IconAppGallery,
  xS as IconAppStore,
  YP as IconArchiveDownloadRegular,
  nB as IconArchiveDownloadThin,
  iE as IconArchiveRarRegular,
  aE as IconArchiveRarThin,
  eB as IconArchiveRegular,
  oB as IconArchiveThin,
  cB as IconArchiveUploadRegular,
  sB as IconArchiveUploadThin,
  _E as IconArchiveZipRegular,
  tE as IconArchiveZipThin,
  FS as IconArrowCircleDownFill,
  bS as IconArrowCircleDownRegular,
  CS as IconArrowCircleDownThin,
  wS as IconArrowCircleUpFill,
  yS as IconArrowCircleUpRegular,
  vS as IconArrowCircleUpThin,
  kS as IconArrowDownRegular,
  SS as IconArrowDownThin,
  US as IconArrowLeftLongRegular,
  GS as IconArrowLeftLongThin,
  DS as IconArrowLeftRegular,
  AS as IconArrowLeftThin,
  MS as IconArrowRightRegular,
  PS as IconArrowRightThin,
  BS as IconArrowUpRegular,
  LS as IconArrowUpThin,
  ML as IconAtSymbolRegular,
  PL as IconAtSymbolThin,
  NG as IconBagFill,
  OG as IconBagRegular,
  KG as IconBagThin,
  RW as IconBalanceRegular,
  TW as IconBalanceThin,
  _W as IconBillFill,
  tW as IconBillRegular,
  iW as IconBillThin,
  xU as IconBinarLeftRegular,
  IU as IconBinarLeftThin,
  RU as IconBinarRegular,
  TU as IconBinarRightRegular,
  FU as IconBinarRightThin,
  bU as IconBinarThin,
  CU as IconBinarTopRegular,
  wU as IconBinarTopThin,
  BL as IconBoldRegular,
  LL as IconBoldThin,
  BH as IconBoltFill,
  GH as IconBoltOffFill,
  WH as IconBoltOffRegular,
  VH as IconBoltOffThin,
  LH as IconBoltRegular,
  UH as IconBoltThin,
  hW as IconBonusFill,
  lW as IconBonusRegular,
  uW as IconBonusThin,
  kP as IconBookFill,
  SP as IconBookRegular,
  DP as IconBookThin,
  tB as IconBookmarkRegular,
  rB as IconBookmarkRemoveRegular,
  _B as IconBookmarkRemoveThin,
  iB as IconBookmarkThin,
  CW as IconBoxFill,
  FW as IconBoxRegular,
  bW as IconBoxThin,
  oG as IconBuildingRegular,
  rG as IconBuildingThin,
  FG as IconBurgerRegular,
  bG as IconBurgerThin,
  qD as IconCalendarMonthFill,
  ND as IconCalendarMonthRegular,
  OD as IconCalendarMonthThin,
  KD as IconCalendarTodayFill,
  QD as IconCalendarTodayRegular,
  ZD as IconCalendarTodayThin,
  jD as IconCalendarViewDayRegular,
  JD as IconCalendarViewDayThin,
  XD as IconCalendarViewMonthRegular,
  YD as IconCalendarViewMonthThin,
  nA as IconCalendarViewWeekRegular,
  cA as IconCalendarViewWeekThin,
  sA as IconCalendarWeekFill,
  eA as IconCalendarWeekRegular,
  oA as IconCalendarWeekThin,
  AH as IconCameraFill,
  MH as IconCameraRegular,
  PH as IconCameraThin,
  AA as IconCarFill,
  SA as IconCarRegular,
  DA as IconCarThin,
  QG as IconCardFill,
  ZG as IconCardRegular,
  jG as IconCardThin,
  EG as IconCartFill,
  zG as IconCartRegular,
  qG as IconCartThin,
  CM as IconCashFlowRegular,
  sE as IconCashbackHistoryRegular,
  eE as IconCashbackHistoryThin,
  lM as IconCashbackRegular,
  uM as IconCashbackThin,
  wM as IconCashflowThin,
  PM as IconChairFill,
  BM as IconChairRegular,
  LM as IconChairThin,
  yU as IconChartBarFill,
  vU as IconChartBarRegular,
  kU as IconChartBarThin,
  SU as IconChartDiagramUpRegular,
  DU as IconChartDiagramUpThin,
  AU as IconChartPieRegular,
  MU as IconChartPieThin,
  Uz as IconCheckIndicatorRegular,
  WS as IconChevronDoubleLeftRegular,
  VS as IconChevronDoubleLeftThin,
  HS as IconChevronDoubleRightRegular,
  ES as IconChevronDoubleRightThin,
  zS as IconChevronDownRegular,
  qS as IconChevronDownThin,
  NS as IconChevronLeftRegular,
  OS as IconChevronLeftThin,
  KS as IconChevronRightRegular,
  QS as IconChevronRightThin,
  ZS as IconChevronUpRegular,
  jS as IconChevronUpThin,
  UM as IconChildFill,
  GM as IconChildRegular,
  WM as IconChildThin,
  PW as IconCircleAddFill,
  BW as IconCircleAddRegular,
  LW as IconCircleAddThin,
  nV as IconCircleBlockRegular,
  cV as IconCircleBlockThin,
  UW as IconCircleCloseFill,
  GW as IconCircleCloseRegular,
  WW as IconCircleCloseThin,
  ZW as IconCircleDoneFill,
  jW as IconCircleDoneRegular,
  JW as IconCircleDoneThin,
  OW as IconCircleErrorFill,
  KW as IconCircleErrorRegular,
  QW as IconCircleErrorThin,
  OB as IconCircleFill,
  DW as IconCircleHelpFill,
  AW as IconCircleHelpRegular,
  MW as IconCircleHelpThin,
  VW as IconCircleInfoFill,
  HW as IconCircleInfoRegular,
  EW as IconCircleInfoThin,
  dH as IconCirclePauseFill,
  fH as IconCirclePauseRegular,
  lH as IconCirclePauseThin,
  uH as IconCirclePlayFill,
  hH as IconCirclePlayRegular,
  $H as IconCirclePlayThin,
  qB as IconCircleRegular,
  zW as IconCircleRemoveFill,
  qW as IconCircleRemoveRegular,
  NW as IconCircleRemoveThin,
  Pz as IconCircleReplyFill,
  Lz as IconCircleReplyRegular,
  Bz as IconCircleReplyThin,
  XW as IconCircleSupportRegular,
  YW as IconCircleSupportThin,
  NB as IconCircleThin,
  yM as IconClientTransitionRegular,
  vM as IconClientTransitionThin,
  aB as IconClipRegular,
  dB as IconClipThin,
  RG as IconCloseRegular,
  TG as IconCloseThin,
  AP as IconCloudDownloadFill,
  MP as IconCloudDownloadRegular,
  PP as IconCloudDownloadThin,
  GP as IconCloudFill,
  WP as IconCloudRegular,
  VP as IconCloudThin,
  BP as IconCloudUploadFill,
  LP as IconCloudUploadRegular,
  UP as IconCloudUploadThin,
  JG as IconCoin1Fill,
  XG as IconCoin1Regular,
  YG as IconCoin1Thin,
  nW as IconCoin2Fill,
  cW as IconCoin2Regular,
  sW as IconCoin2Thin,
  eW as IconCoin3Fill,
  oW as IconCoin3Regular,
  rW as IconCoin3Thin,
  JS as IconCollapseAllRegular,
  XS as IconCollapseAllThin,
  YS as IconCollapseRegular,
  nD as IconCollapseThin,
  Sz as IconColumns2Regular,
  Dz as IconColumns2Thin,
  Az as IconColumns3Regular,
  Mz as IconColumns3Thin,
  MA as IconCookieFill,
  PA as IconCookieRegular,
  BA as IconCookieThin,
  HP as IconCopyFill,
  EP as IconCopyRegular,
  zP as IconCopyThin,
  iz as IconCropFill,
  az as IconCropRegular,
  dz as IconCropThin,
  FA as IconDeliveryRegular,
  bA as IconDeliveryThin,
  pH as IconDesktopRegular,
  mH as IconDesktopThin,
  JE as IconDiamondRegular,
  XE as IconDiamondThin,
  PE as IconDocumentCsvRegular,
  BE as IconDocumentCsvThin,
  VE as IconDocumentDocRegular,
  HE as IconDocumentDocThin,
  GE as IconDocumentDocxRegular,
  WE as IconDocumentDocxThin,
  EE as IconDocumentPdfRegular,
  zE as IconDocumentPdfThin,
  vE as IconDocumentPptRegular,
  kE as IconDocumentPptThin,
  wE as IconDocumentPptxRegular,
  yE as IconDocumentPptxThin,
  LE as IconDocumentTxtRegular,
  UE as IconDocumentTxtThin,
  AE as IconDocumentXlsRegular,
  ME as IconDocumentXlsThin,
  SE as IconDocumentXlsxRegular,
  DE as IconDocumentXlsxThin,
  sV as IconDoneRegular,
  eV as IconDoneThin,
  rz as IconDoubleStarFill,
  _z as IconDoubleStarRegular,
  tz as IconDoubleStarThin,
  fB as IconDownloadRegular,
  lB as IconDownloadThin,
  QA as IconDzen,
  ZA as IconDzenDark,
  lV as IconEditRegular,
  uV as IconEditThin,
  MD as IconEmptyFlag,
  PD as IconEmptyFlagSquare,
  xG as IconExitRegular,
  IG as IconExitThin,
  cD as IconExpandAllRegular,
  sD as IconExpandAllThin,
  eD as IconExpandRegular,
  oD as IconExpandThin,
  Cz as IconFaceIdFill,
  wz as IconFaceIdRegular,
  yz as IconFaceIdThin,
  XA as IconFacebook,
  YA as IconFacebookDark,
  $B as IconFileAddRegular,
  pB as IconFileAddThin,
  uB as IconFileChartRegular,
  hB as IconFileChartThin,
  mB as IconFileCopyRegular,
  gB as IconFileCopyThin,
  qP as IconFileDescriptionFill,
  NP as IconFileDescriptionRegular,
  OP as IconFileDescriptionThin,
  xB as IconFileDownloadRegular,
  IB as IconFileDownloadThin,
  KP as IconFileFill,
  RB as IconFilePadRegular,
  TB as IconFilePadThin,
  QP as IconFileRegular,
  FB as IconFileRemoveRegular,
  bB as IconFileRemoveThin,
  ZP as IconFileThin,
  CB as IconFileUploadRegular,
  wB as IconFileUploadThin,
  aL as IconFilterArrowDownRegular,
  dL as IconFilterArrowDownThin,
  fL as IconFilterArrowUpRegular,
  lL as IconFilterArrowUpThin,
  HL as IconFilterFill,
  EL as IconFilterRegular,
  zL as IconFilterThin,
  pM as IconFirstFill,
  hM as IconFirstRegular,
  $M as IconFirstThin,
  yB as IconFolderAddRegular,
  vB as IconFolderAddThin,
  kB as IconFolderDownloadRegular,
  SB as IconFolderDownloadThin,
  jP as IconFolderFill,
  JP as IconFolderRegular,
  DB as IconFolderRemoveRegular,
  AB as IconFolderRemoveThin,
  XP as IconFolderThin,
  MB as IconFolderUploadRegular,
  PB as IconFolderUploadThin,
  LA as IconFoodRegular,
  UA as IconFoodThin,
  RL as IconFormatCenterRegular,
  TL as IconFormatCenterThin,
  FL as IconFormatJustifyRegular,
  bL as IconFormatJustifyThin,
  CL as IconFormatLeftRegular,
  wL as IconFormatLeftThin,
  yL as IconFormatRightRegular,
  vL as IconFormatRightThin,
  GA as IconFuelRegular,
  WA as IconFuelThin,
  rD as IconFullscreenExitRegular,
  _D as IconFullscreenExitThin,
  tD as IconFullscreenOpenRegular,
  iD as IconFullscreenOpenThin,
  IS as IconGalaxyStore,
  FP as IconGhostFill,
  bP as IconGhostRegular,
  CP as IconGhostThin,
  aW as IconGiftFill,
  dW as IconGiftRegular,
  fW as IconGiftThin,
  sG as IconGlobeRegular,
  eG as IconGlobeThin,
  RS as IconGooglePlay,
  wP as IconGraduateFill,
  yP as IconGraduateRegular,
  vP as IconGraduateThin,
  PU as IconGraphDownRegular,
  BU as IconGraphDownThin,
  LU as IconGraphUpRegular,
  UU as IconGraphUpThin,
  jM as IconGroupAddFill,
  JM as IconGroupAddRegular,
  XM as IconGroupAddThin,
  YM as IconGroupFill,
  nP as IconGroupRegular,
  cP as IconGroupRemoveFill,
  sP as IconGroupRemoveRegular,
  eP as IconGroupRemoveThin,
  tP as IconGroupThin,
  oP as IconGroupsFill,
  rP as IconGroupsRegular,
  _P as IconGroupsThin,
  hV as IconHeartFill,
  $V as IconHeartRegular,
  pV as IconHeartThin,
  mV as IconHide2Regular,
  gV as IconHide2Thin,
  xV as IconHideFill,
  IV as IconHideRegular,
  RV as IconHideThin,
  rA as IconHistoryRegular,
  _A as IconHistoryThin,
  EU as IconHomeFill,
  zU as IconHomeRegular,
  qU as IconHomeThin,
  bz as IconIOSFill,
  gH as IconImageFill,
  lE as IconImageGifRegular,
  uE as IconImageGifThin,
  pE as IconImageImgRegular,
  mE as IconImageImgThin,
  oE as IconImageJpgRegular,
  rE as IconImageJpgThin,
  dE as IconImagePngRegular,
  fE as IconImagePngThin,
  xH as IconImageRegular,
  hE as IconImageSvgRegular,
  $E as IconImageSvgThin,
  IH as IconImageThin,
  nM as IconInstagram,
  cM as IconInstagramDark,
  TV as IconKeyFill,
  FV as IconKeyRegular,
  bV as IconKeyThin,
  sz as IconKingFill,
  ez as IconKingRegular,
  oz as IconKingThin,
  BD as IconKz,
  LD as IconKzSquare,
  hz as IconLanguagesEngFill,
  uz as IconLanguagesEngRegular,
  Iz as IconLanguagesKaFill,
  xz as IconLanguagesKaRegular,
  pz as IconLanguagesRoFill,
  $z as IconLanguagesRoRegular,
  gz as IconLanguagesRuFill,
  mz as IconLanguagesRuRegular,
  RH as IconLaptopRegular,
  TH as IconLaptopThin,
  GU as IconLinearRegular,
  WU as IconLinearThin,
  NM as IconLinkMobileRegular,
  OM as IconLinkMobileThin,
  CV as IconLinkRegular,
  wV as IconLinkRemoveRegular,
  yV as IconLinkRemoveThin,
  vV as IconLinkThin,
  WL as IconListNumberedRegular,
  VL as IconListNumberedThin,
  kL as IconListRegular,
  SL as IconListThin,
  kV as IconLockFill,
  SV as IconLockRegular,
  DV as IconLockThin,
  mG as IconLoginRegular,
  gG as IconLoginThin,
  mA as IconMaestro,
  gA as IconMaestroDark,
  tU as IconMailFill,
  iU as IconMailRegular,
  aU as IconMailThin,
  NU as IconMapFill,
  QU as IconMapPinFill,
  ZU as IconMapPinRegular,
  jU as IconMapPinThin,
  OU as IconMapRegular,
  KU as IconMapThin,
  $A as IconMastercard,
  pA as IconMastercardDark,
  UD as IconMd,
  GD as IconMdSquare,
  gE as IconMediaAviRegular,
  xE as IconMediaAviThin,
  bE as IconMediaMp3Regular,
  CE as IconMediaMp3Thin,
  TE as IconMediaMp4Regular,
  FE as IconMediaMp4Thin,
  IE as IconMediaWavRegular,
  RE as IconMediaWavThin,
  pU as IconMessageCommentsFill,
  mU as IconMessageCommentsRegular,
  gU as IconMessageCommentsThin,
  uU as IconMessageDotsFill,
  hU as IconMessageDotsRegular,
  $U as IconMessageDotsThin,
  sU as IconMessageFill,
  eU as IconMessageRegular,
  oU as IconMessageThin,
  xA as IconMir,
  IA as IconMirDark,
  CH as IconMobileRegular,
  wH as IconMobileThin,
  gW as IconMoneyFill,
  kM as IconMoneyOutputRegular,
  SM as IconMoneyOutputThin,
  xW as IconMoneyRegular,
  IW as IconMoneyThin,
  AV as IconMoonFill,
  MV as IconMoonRegular,
  PV as IconMoonThin,
  CG as IconMoreGridLRegular,
  wG as IconMoreGridLThin,
  yG as IconMoreGridMRegular,
  vG as IconMoreGridMThin,
  kG as IconMoreGridSRegular,
  SG as IconMoreGridSThin,
  DG as IconMoreHorizontRegular,
  AG as IconMoreHorizontThin,
  fG as IconMoreVertRegular,
  lG as IconMoreVertThin,
  nG as IconNavigationRegular,
  cG as IconNavigationThin,
  BV as IconNetworkRegular,
  LV as IconNetworkThin,
  aD as IconNorthEastRegular,
  dD as IconNorthEastThin,
  fD as IconNorthWestRegular,
  lD as IconNorthWestThin,
  UB as IconNoteEditFill,
  BB as IconNoteEditRegular,
  LB as IconNoteEditThin,
  iL as IconNotificationFill,
  tL as IconNotificationRegular,
  rL as IconNotificationRemoveRegular,
  _L as IconNotificationRemoveThin,
  oL as IconNotificationThin,
  jA as IconOk,
  JA as IconOkDark,
  GB as IconPadRegular,
  WB as IconPadThin,
  $G as IconPanelCloseRegular,
  pG as IconPanelCloseThin,
  uG as IconPanelOpenRegular,
  hG as IconPanelOpenThin,
  JU as IconParkingFill,
  XU as IconParkingRegular,
  YU as IconParkingThin,
  FH as IconPauseRegular,
  bH as IconPauseThin,
  mM as IconPayFill,
  gM as IconPayRegular,
  xM as IconPayThin,
  IM as IconPercentFill,
  RM as IconPercentRegular,
  TM as IconPercentThin,
  VM as IconPetPawFill,
  HM as IconPetPawRegular,
  EM as IconPetPawThin,
  dU as IconPhoneFill,
  fU as IconPhoneRegular,
  lU as IconPhoneThin,
  KB as IconPlaceholderRegular,
  QB as IconPlaceholderThin,
  yH as IconPlayFill,
  vH as IconPlayRegular,
  kH as IconPlayThin,
  CA as IconPrintRegular,
  wA as IconPrintThin,
  $W as IconPromocodeFill,
  pW as IconPromocodeRegular,
  mW as IconPromocodeThin,
  WG as IconQrcodeFill,
  VG as IconQrcodeRegular,
  HG as IconQrcodeThin,
  YE as IconQueenFill,
  nz as IconQueenRegular,
  cz as IconQueenThin,
  VA as IconRcMobileRegular,
  HA as IconRcMobileThin,
  iP as IconReactionSadFill,
  aP as IconReactionSadRegular,
  dP as IconReactionSadThin,
  fP as IconReactionSmileFill,
  lP as IconReactionSmileRegular,
  uP as IconReactionSmileThin,
  uD as IconRedoRegular,
  hD as IconRedoThin,
  $D as IconRefreshRegular,
  pD as IconRefreshThin,
  mD as IconReplyRegular,
  gD as IconReplyThin,
  xD as IconRestoreRegular,
  ID as IconRestoreThin,
  VU as IconRfmStatisticRegular,
  HU as IconRfmStatisticThin,
  WD as IconRu,
  VD as IconRuSquare,
  TS as IconRuStore,
  sM as IconRutube,
  eM as IconRutubeDark,
  Rz as IconSbp,
  Tz as IconSbpDark,
  tA as IconScheduleFill,
  iA as IconScheduleRegular,
  aA as IconScheduleThin,
  lz as IconSearchCategoriesRegular,
  fz as IconSearchCategoriesThin,
  UV as IconSearchRegular,
  GV as IconSearchThin,
  rU as IconSendRegular,
  _U as IconSendThin,
  qA as IconServiceFill,
  EA as IconServiceRegular,
  zA as IconServiceThin,
  qL as IconSettingsFill,
  NL as IconSettingsRegular,
  OL as IconSettingsThin,
  WV as IconShareAltFill,
  VV as IconShareAltRegular,
  HV as IconShareAltThin,
  EV as IconShareRegular,
  zV as IconShareThin,
  fV as IconShieldDoneFill,
  JB as IconShieldFill,
  ZB as IconShieldRegular,
  jB as IconShieldThin,
  qV as IconShowFill,
  NV as IconShowRegular,
  OV as IconShowThin,
  KV as IconSignalRegular,
  QV as IconSignalThin,
  KL as IconSliderHorizontRegular,
  QL as IconSliderHorizontThin,
  ZL as IconSliderVertRegular,
  jL as IconSliderVertThin,
  wD as IconSortDownRegular,
  RD as IconSortHorisontRegular,
  TD as IconSortHorisontThin,
  CD as IconSortUpRegular,
  FD as IconSortVertRegular,
  bD as IconSortVertThin,
  yD as IconSouthEastRegular,
  vD as IconSouthEastThin,
  kD as IconSouthWestRegular,
  SD as IconSouthWestThin,
  XB as IconSquareRegular,
  YB as IconSquareThin,
  ZV as IconStar0Regular,
  jV as IconStar0Thin,
  eH as IconStar100Regular,
  JV as IconStar25Regular,
  XV as IconStar25Thin,
  YV as IconStar50Regular,
  nH as IconStar50Thin,
  cH as IconStar75Regular,
  sH as IconStar75Thin,
  VB as IconStickerRegular,
  HB as IconStickerThin,
  oV as IconSubtractRegular,
  rV as IconSubtractThin,
  oH as IconSunFill,
  rH as IconSunRegular,
  _H as IconSunThin,
  DD as IconSyncRegular,
  AD as IconSyncThin,
  uL as IconTableAddRegular,
  hL as IconTableAddThin,
  mL as IconTableRegular,
  $L as IconTableRemoveRegular,
  pL as IconTableRemoveThin,
  gL as IconTableThin,
  SH as IconTabletRegular,
  DH as IconTabletThin,
  vW as IconTagFill,
  wW as IconTagRegular,
  yW as IconTagThin,
  qE as IconTariffBusinessFill,
  NE as IconTariffFranchiseFill,
  OE as IconTariffFreeFill,
  KE as IconTariffGoldFill,
  QE as IconTariffPremiumFill,
  ZE as IconTariffSmartFill,
  jE as IconTariffStandartFill,
  NA as IconTaxiFill,
  OA as IconTaxiRegular,
  KA as IconTaxiThin,
  oM as IconTelegram,
  rM as IconTelegramDark,
  dA as IconTodayFill,
  fA as IconTodayRegular,
  lA as IconTodayThin,
  xL as IconToolbarRegular,
  IL as IconToolbarThin,
  vz as IconTouchIdRegular,
  kz as IconTouchIdThin,
  DL as IconTranslateRegular,
  AL as IconTranslateThin,
  yA as IconTrashFill,
  vA as IconTrashRegular,
  kA as IconTrashThin,
  nL as IconTriangleRegular,
  cL as IconTriangleThin,
  iG as IconTspFill,
  aG as IconTspRegular,
  dG as IconTspThin,
  UL as IconUnderlineRegular,
  GL as IconUnderlineThin,
  tH as IconUnlockFill,
  iH as IconUnlockRegular,
  aH as IconUnlockThin,
  uA as IconUpdateRegular,
  hA as IconUpdateThin,
  EB as IconUploadRegular,
  zB as IconUploadThin,
  hP as IconUserAddFill,
  $P as IconUserAddRegular,
  pP as IconUserAddThin,
  mP as IconUserFill,
  gP as IconUserRegular,
  xP as IconUserRemoveFill,
  IP as IconUserRemoveRegular,
  RP as IconUserRemoveThin,
  TP as IconUserThin,
  HH as IconVideoFill,
  EH as IconVideoRegular,
  zH as IconVideoThin,
  RA as IconVisa,
  TA as IconVisaDark,
  _M as IconVk,
  tM as IconVkDark,
  qH as IconVolumeFullFill,
  NH as IconVolumeFullRegular,
  OH as IconVolumeFullThin,
  KH as IconVolumeHalfFill,
  QH as IconVolumeHalfRegular,
  ZH as IconVolumeHalfThin,
  jH as IconVolumeZeroFill,
  JH as IconVolumeZeroRegular,
  XH as IconVolumeZeroThin,
  kW as IconWalletRegular,
  SW as IconWalletThin,
  iV as IconWarningFill,
  aV as IconWarningRegular,
  dV as IconWarningThin,
  YH as IconWaterFill,
  nE as IconWaterRegular,
  cE as IconWaterThin,
  sL as IconWavyRegular,
  eL as IconWavyThin,
  iM as IconWhatsapp,
  aM as IconWhatsappDark,
  zM as IconWiFiRegular,
  qM as IconWiFiThin,
  MG as IconWidgetAddFill,
  PG as IconWidgetAddRegular,
  BG as IconWidgetAddThin,
  LG as IconWidgetFill,
  UG as IconWidgetRegular,
  GG as IconWidgetThin,
  _G as IconWorldRegular,
  tG as IconWorldThin,
  YL as IconWrenchFill,
  nU as IconWrenchRegular,
  JL as IconWrenchScRegular,
  XL as IconWrenchScThin,
  cU as IconWrenchThin,
  dM as IconYoutube,
  fM as IconYoutubeDark
};
